/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import { Card, Button, Container, Form, Col, Row, InputGroup, Modal } from 'react-bootstrap';
import { NavBar } from "../NavBar";
import { AgGridReact } from 'ag-grid-react';
import "../../CSS/general.css";
import Axios from "axios";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import { getItem } from "../IndexedDBUtils";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AuthenticationContext from "../../Store/Authentication-Context";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoaderGif from "../../images/365 loading.gif";
import { InfoCircle } from 'react-bootstrap-icons';
import { Spinner } from 'react-bootstrap';
import { setItem } from "../../components/IndexedDBUtils";


const Settings = () => {
    const { setAuthContext } = useContext(AuthenticationContext);
    const authContext = useContext(AuthenticationContext);
    const [managed, setManaged] = useState();
    ////const [endUserRecovery, setEndUserRecovery] = useState();
    const [adminEmailAddress, setAdminEmailAddress] = useState();
    const [notificationEmailAddress, setNotificationEmailAddress] = useState();
    const [addNotificationEmail, setAddNotificationEmail] = useState();
    const [emailValidation, setEmailValidation] = useState({ isNotificationEmailValid: true, notificationEmailErrorMessage: "", disabled: true, });
    ////const [notificationType, setNotificationType] = useState();
    ////const [goCardlessID, setGoCardlessID] = useState();
    const [resellerID, setResellerID] = useState();
    ////const [tennantName, setTennantNameD] = useState();
    const [restoreEmailType, setRestoreEmailType] = useState();
    const [encryption, setEncryption] = useState();
    const [encryptionKey, setEncryptionKey] = useState();
    const urlParams = new URLSearchParams(window.location.search);
    const [isLoading, setIsLoading] = useState(true); 
    ////const [groups, setGroups] = useState([]);
    const [popUp, setPopUp] = useState(false);
    ////const [checkboxes, setCheckboxes] = useState({ VeeamAdmin: false, Setting: false, MainPage: false, RestorePage: false, EndUserRestore: false });
    ////const [disabledCheckboxes, setDisabledCheckboxes] = useState({ VeeamAdmin: false, Setting: false, MainPage: false, RestorePage: false, EndUserRestore: false });
    const [deleteConfirmPopUp, setDeleteConfirmPopUp] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [notifyMails, setNotifyMails] = useState([]);
    const [columnDefs, setColumnDefs] = useState([]);
    const [tawkChatSlide, setTawkChatSlide] = useState(true);
    const [newStyleNotificationsSlide, setNewStyleNotificationsSlide] = useState(false);
    // Task 9 (D3/N6) — defaults to true because the column does: an organisation that has never
    // touched this is subscribed, and the UI must not imply otherwise before the fetch lands.
    const [suppressionExpirySlide, setSuppressionExpirySlide] = useState(true);
    const tenantDomain = sessionStorage.getItem("ManageTenantDomain") ? sessionStorage.getItem("ManageTenantDomain") : "";
    const [isSaving, setIsSaving] = useState(false);
    const [brandings, setBrandings] = useState({
        BackGround: '#ffffff',
        PrimaryText: '#000000',
        SecondaryText: '#000000',
        SecondaryIcon: '#5191ce',
        ButtonBack: '#5191ce',
        ButtonText: '#FFFFFF',
        HeaderBack: '#5191ce',
        HeaderText: '#ffffff',
        Domain:'',
        Logo: null,
        Splash:null
    });
    const bgImageRef = useRef(null);
    const mgImageRef = useRef(null);
    const [defaultBranding, setDefaultBranding] = useState([]);
    const [selectedDefaultBranding, setSelectedDefaultBranding] = useState("");
    const [isReseller, setIsReseller] = useState(false);
    // Function to convert color names to hex
    const getColorHex = (colorName) => {
        const ctx = document.createElement("canvas").getContext("2d");
        ctx.fillStyle = colorName;
        return ctx.fillStyle; // Returns hex if valid, or unchanged name if invalid
    };

    const handleSlideChange = () => {
        const newValue = !tawkChatSlide;
        setTawkChatSlide(newValue);
        TawkChat(newValue);
    };

    const handleNewStyleNotificationsChange = () => {
        const newValue = !newStyleNotificationsSlide;
        setNewStyleNotificationsSlide(newValue);
        NewStyleNotifications(newValue);
    };

    const handleSuppressionExpiryChange = () => {
        const newValue = !suppressionExpirySlide;
        setSuppressionExpirySlide(newValue);
        SuppressionExpiryWarnings(newValue);
    };

    const handleColorChange = (event) => {
        //setColor(event.target.value);
        //setColorInput(event.target.value); 
        const { name, value } = event.target;
        setBrandings((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleColorInputChange = (event) => {
        const { name, value } = event.target;
        setBrandings((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        //setColorInput(event.target.value);
    };
    
    const handleColorInputBlur = (event) => {
        const { name } = event.target;
        const hexColor = getColorHex(brandings[name]); // Convert only on blur
        setBrandings((prevState) => ({
            ...prevState,
            [name]: hexColor,
        }));
    };
    const toBase64 = (file) => {
        ////if (brandings.BGImage.toLowerCase.includes('image')) {
        if ((typeof file).toLowerCase().includes('string')) {
            return file;
        }
        else {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });
        }
    };
    const onFileChange = async (event) =>{
        const { name, files } = event.target;
        const file = files[0];
        const maxSizeInBytes = 5 * 1024 * 1024; 
        if (file && file.size > maxSizeInBytes) {
            showToast("warning", 'Please select a image less then 5 MB');
            event.target.value = null;
            return;
        }

        const image = new Image();
        const objectUrl = URL.createObjectURL(file);

        image.src = objectUrl;

        if (name === 'Logo') {
            image.onload = async () => {
                const ratio = image.width / image.height;

                URL.revokeObjectURL(objectUrl);

                if (ratio < 4 || ratio > 10){
                    showToast("warning", "Please upload an image with wider aspect ratio between 4:1 and 10:1 (for example, 1600 x 400 to 2000 x 200 pixels).");
                    if (bgImageRef.current) bgImageRef.current.value = null;
                    return;
                }
                var base64 = await toBase64(files[0])
                setBrandings((prevState) => ({
                    ...prevState,
                    [name]: base64, // Ensure we are correctly setting the image
                }));
            };

        }
        else{
            image.onload = async () => {

                URL.revokeObjectURL(objectUrl);
                if (image.width < 1920 || image.height < 1080) {
                    showToast("warning", "Please upload an image at least 1920x1080 for splash image.");
                    if (mgImageRef.current) mgImageRef.current.value = null;
                    return;
                }
                if (image.width < image.height) {
                    showToast("warning", "Splash image should be landscape (wider than tall).");
                    if (mgImageRef.current) mgImageRef.current.value = null;
                    return;
                }
                var base64 = await toBase64(files[0])
                setBrandings((prevState) => ({
                    ...prevState,
                    [name]: base64, // Ensure we are correctly setting the image
                }));
            };
        }



        
    }
    
    const defaultBrandingList = async () => {
        var tokenString = await setAuthContext("", new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        
            try {
                const response = await Axios.get(API_ROUTE + Routes.GET_ALL_BRANDING_SETTINGS + "/test/test", config);
                let result = response.data;
                if (result !== "") {
                    ////console.log(result)
                    setDefaultBranding(result)
                }
            }
            catch (reason) {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            }
    }
    const handleDefaultThemeChange = async (event) => {
        const selectedId = event.target.value;
        if (selectedId !== "none-selected") {
            const item = defaultBranding.find(item => item.themeId.toString() === selectedId.toString());
            setBrandings((prevState) => ({
                ...prevState,
                BackGround: item.backGround,
                PrimaryText: item.primaryText,
                SecondaryText: item.secondaryText,
                SecondaryIcon: item.secondaryIcon,
                ButtonBack: item.buttonBack,
                ButtonText: item.buttonText,
                HeaderBack: item.headerBack,
                HeaderText: item.headerText,
                Logo: item.logo ,
                Splash: item.splash
            }));
            setSelectedDefaultBranding(selectedId)
            if (bgImageRef.current) bgImageRef.current.value = null;
            if (mgImageRef.current) mgImageRef.current.value = null;
        }
        else {
            setSelectedDefaultBranding("none-selected")
        }
        
    }
    const getMutedColor =(colorInput)=> {
        // Create a dummy element to parse any valid CSS color
        const dummy = document.createElement('div');
        dummy.style.color = colorInput;
        document.body.appendChild(dummy);
        const computed = getComputedStyle(dummy).color;
        document.body.removeChild(dummy);

        // Extract RGB components
        const rgb = computed.match(/\d+/g).map(Number);
        let [r, g, b] = rgb;

        // Convert RGB to HSL
        r /= 255; g /= 255; b /= 255;
        let max = Math.max(r, g, b), min = Math.min(r, g, b);
        let h, s, l = (max + min) / 2;

        if (max === min) {
            h = s = 0; // gray
        } else {
            let d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            // eslint-disable-next-line default-case
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h *= 60;
        }

        // Muted color: lower saturation, adjust lightness for contrast
        const mutedS = Math.max(10, s * 0.3 * 100); // 10�30% saturation
        const mutedL = l < 0.5 ? l * 100 + 25 : l * 100 - 50; // push away from bg

        return `hsl(${Math.round(h)}, ${Math.round(mutedS)}%, ${Math.round(mutedL)}%)`;
    }
    const getDisabledColor=(hexColor)=> {
        // Convert hex to RGB
        const hexToRgb = (hex) => {
            hex = hex.replace('#', '');
            if (hex.length === 3) {
                hex = hex.split('').map(c => c + c).join('');
            }
            const bigint = parseInt(hex, 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return [r, g, b];
        };

        const [r, g, b] = hexToRgb(hexColor);

        // Calculate brightness (simple perception-based formula)
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;

        let newR, newG, newB;

        if (brightness > 200) {
            // Background is light � darken it
            newR = Math.max(r - 30, 0);
            newG = Math.max(g - 30, 0);
            newB = Math.max(b - 30, 0);
        } else {
            // Background is dark � lighten it
            newR = Math.min(r + 50, 255);
            newG = Math.min(g + 50, 255);
            newB = Math.min(b + 50, 255);
        }

        return `rgb(${newR}, ${newG}, ${newB})`;
    }
    const brandingSave = async () => {
        ////console.log(brandings)
        
        if (brandings.BackGround === '' || brandings.PrimaryText === '' || brandings.SecondaryText === '' || brandings.SecondaryIcon === '' || brandings.ButtonBack === '' || brandings.ButtonText === '' || brandings.HeaderBack === '' || brandings.HeaderText === '' || brandings.Domain === '') {
            showToast("warning", "Please fill in all the required fields.");
            return; // Exit the function if any field is empty
        }
        if (!brandings.Logo) {
            
            showToast("warning", "Please upload Logo image.");
            

            return;
        }
        if (!brandings.Logo && !brandings.Splash) {
            showToast("warning", "Please upload Splash image.");

            return;
        }
        if (brandings.PrimaryText === brandings.BackGround || brandings.SecondaryText === brandings.BackGround || brandings.SecondaryIcon === brandings.BackGround) {
            if (brandings.PrimaryText === brandings.BackGround) {
                showToast("warning", "Background and Primary text colors cannot be the same.");

                return;
            }
            if (brandings.SecondaryText === brandings.BackGround) {
                showToast("warning", "Background and Secondary text colors cannot be the same.");

                return;
            }
            if (brandings.SecondaryIcon === brandings.BackGround) {
                showToast("warning", "Background and Secondary icon colors cannot be the same.");

                return;
            }
        }
        
        const defaultDomainValues = defaultBranding.map(d => d.domain);
        if (defaultDomainValues.includes(brandings.Domain)){
            showToast("warning", "Invalid domain name. Please enter a valid domain name.");

            return;
        }
        setIsSaving(true);
        var tokenString = await setAuthContext("", new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        //const bgImageBase64 = brandings.BGImage ? await toBase64(brandings.BGImage) : null;
        //const mbgImageBase64 = brandings.MBGImage ? await toBase64(brandings.MBGImage) : null;
        
        const bgImageBase64 = brandings.Logo ? brandings.Logo : null;
        const mbgImageBase64 = brandings.Splash ? brandings.Splash : null;
        const payload = {
            OrgId: urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId"),
            BackGround: brandings.BackGround,
            PrimaryText: brandings.PrimaryText,
            SecondaryText: brandings.SecondaryText,
            SecondaryIcon: brandings.SecondaryIcon,
            ButtonBack: brandings.ButtonBack,
            ButtonText: brandings.ButtonText,
            HeaderBack: brandings.HeaderBack,
            HeaderText: brandings.HeaderText,
            Domain: brandings.Domain,
            Logo: bgImageBase64, // Base64 encoded image
            Splash: mbgImageBase64, // Base64 encoded image
        };
        await Axios.post(API_ROUTE + Routes.ADD_BRANDING, payload, config)
            .then((response) => {
                if (response.data.toLowerCase() ==='no access'){
                    setIsSaving(false);
                    showToast("error", 'Domain is already in use.');

                    return false;
                }
                else if (response.data.trim() === ""){
                    setIsSaving(false);
                    showToast("error", 'Error saving branding.');

                    return false;
                }
                else{
                    setIsSaving(false);
                    /////
//                    let color = payload.SecondaryText;
//                    let secondaryIconColor = payload.SecondaryIcon;
//                    let upArrow = `<svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512" height="512" viewBox="0 0 512 512">
//    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="${color}" stroke="none">
//      <path d="M2450 3939 c-35 -15 -304 -279 -1223 -1197 -693 -692 -1187 -1193 -1198 -1215 -63 -121 -11 -279 112 -341 68 -33 162 -36 229 -5 35 15 284 259 1118 1092 l1072 1072 1073 -1072 c833 -833 1082 -1077 1117 -1092 67 -31 161 -28 229 5 123 62 175 220 112 341 -11 22 -505 523 -1198 1215 -919 918 -1188 1182 -1223 1197 -30 14 -66 21 -110 21 -44 0 -80 -7 -110 -21z"/>
//    </g>
//  </svg>`;
//                    let downArrowsvg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="512" height="512">
//<path d="M0 0 C10.90320287 8.90330234 20.60026438 19.4652861 30.52832031 29.41479492 C32.37221641 31.25897356 34.21633366 33.10293111 36.06065369 34.94668579 C40.00887031 38.89438165 43.95527255 42.84388353 47.90039825 46.7946682 C53.60417621 52.50662237 59.31076017 58.21576656 65.01800177 63.9242597 C74.28072659 73.18916549 83.54122267 82.4562956 92.80029297 91.72485352 C101.78706709 100.72082657 110.77490574 109.71573388 119.76416016 118.70922852 C120.31957565 119.26490673 120.87499114 119.82058494 121.4472374 120.39310189 C124.23399384 123.1811635 127.02077103 125.96920437 129.80755854 128.75723493 C152.87492315 151.83494239 175.9386604 174.91627177 199 198 C202.04071689 196.64001476 204.13390978 195.11286053 206.47841072 192.75651169 C207.15250327 192.08393444 207.82659582 191.41135719 208.52111542 190.71839881 C209.25359588 189.97736419 209.98607634 189.23632957 210.74075317 188.47283936 C211.91748464 187.29443776 211.91748464 187.29443776 213.11798847 186.09223008 C215.75415583 183.44997488 218.38310363 180.8006499 221.01220703 178.15136719 C222.89756878 176.25889516 224.78333599 174.36683606 226.66966248 172.47532654 C230.73614455 168.39624473 234.79916458 164.31374093 238.86008072 160.22911835 C244.74035303 154.31488266 250.62805226 148.40808383 256.51797806 142.50346354 C266.08540225 132.91213985 275.64982004 123.31782539 285.2109375 113.72021484 C285.78324104 113.14573106 286.35554458 112.57124727 286.94519065 111.97935489 C295.05856932 103.8347859 303.1689422 95.68723031 311.27809535 87.53845444 C311.84857974 86.96518342 312.41906414 86.3919124 313.00683594 85.80126953 C313.57662116 85.22869725 314.14640638 84.65612497 314.73345782 84.06620201 C324.24782303 74.5057023 333.76995376 64.95298047 343.29843605 55.40655065 C349.17136922 49.52193401 355.03771846 43.63090358 360.89566939 37.73137173 C364.91497017 33.68456862 368.94154037 29.64509409 372.97380872 25.61121216 C375.29715998 23.28645852 377.61601756 20.95751767 379.92832375 18.62177086 C382.44211873 16.08348968 384.96808933 13.55795779 387.49734497 11.03509521 C388.2164411 10.30298348 388.93553723 9.57087175 389.67642415 8.81657481 C397.49741907 1.07190082 406.49038547 -5.16814087 417.81054688 -5.3293457 C418.49181641 -5.32378662 419.17308594 -5.31822754 419.875 -5.3125 C420.58462891 -5.30758545 421.29425781 -5.3026709 422.02539062 -5.29760742 C427.47428387 -5.17542088 431.18604445 -4.49294127 436 -2 C436.66128906 -1.6596875 437.32257813 -1.319375 438.00390625 -0.96875 C446.57719924 3.84661001 452.47696555 11.46453712 455.5859375 20.75 C457.86455012 33.13189498 455.76128572 43.25567272 448.83117712 53.53408873 C445.57064212 57.92481092 441.72108274 61.69769753 437.84858704 65.54582214 C436.93650598 66.4639943 436.02442493 67.38216646 435.08470505 68.32816201 C432.57223324 70.85693132 430.05059391 73.37637568 427.52722609 75.89426601 C424.79984749 78.61896181 422.0811145 81.35226243 419.3611908 84.08439636 C414.0388009 89.42778877 408.70823463 94.76295039 403.37444148 100.09495779 C399.03741202 104.43067719 394.70295555 108.76895269 390.37029076 113.10903358 C389.12001494 114.3614087 387.86973827 115.61378297 386.61946076 116.8661564 C385.99707704 117.48958365 385.37469332 118.1130109 384.73344948 118.75532988 C372.97573683 130.5319235 361.20808809 142.29854983 349.4375188 154.06229124 C338.68062552 164.81360876 327.93699519 175.57807011 317.19945631 186.3487142 C306.16058061 197.42135835 295.11241572 208.48465631 284.05433339 219.53812009 C277.85160609 225.73860614 271.65264926 231.94275253 265.46352577 238.1568203 C260.19503429 243.44636545 254.91785668 248.72705395 249.62940273 253.99664374 C246.93412039 256.68279402 244.24293975 259.37272837 241.562603 262.07379913 C238.65068407 265.00799258 235.71957691 267.92225523 232.78633118 270.83512878 C231.95089273 271.68308508 231.11545429 272.53104137 230.25469953 273.40469331 C220.63811538 282.87909886 211.60977598 287.28966509 198.21289062 287.31689453 C183.63273515 287.04970164 174.40080902 277.70309677 164.61239624 267.8865509 C163.24254497 266.52455465 163.24254497 266.52455465 161.84501994 265.13504332 C159.32764286 262.63175479 156.81646289 260.12233132 154.3063426 257.61176908 C151.59140088 254.89848362 148.87075919 252.19092315 146.15092468 249.48254395 C140.21394615 243.56834868 134.28437844 237.64676057 128.35625029 231.72369599 C124.65137579 228.02208517 120.94487254 224.32210828 117.23802567 220.62247276 C106.96440471 210.36840613 96.6923573 200.11277073 86.42705345 189.85037708 C85.77106648 189.19457768 85.11507951 188.53877828 84.43921415 187.86310617 C83.10954039 186.53379865 81.7798679 185.20448986 80.45019667 183.8751798 C79.79019622 183.21536217 79.13019577 182.55554453 78.45019531 181.87573242 C77.78938609 181.21510375 77.12857687 180.55447508 76.44774313 179.87382736 C65.73710227 169.1667291 55.01476638 158.47142634 44.28722672 147.78126172 C33.25988995 136.79203621 22.24196621 125.79344751 11.23351729 114.78530043 C5.05787709 108.61024403 -1.12163254 102.43917706 -7.31145096 96.27832985 C-12.58079484 91.03353706 -17.84139134 85.78016072 -23.09096076 80.51557253 C-25.7669612 77.83241953 -28.4467613 75.15338947 -31.13771629 72.48522758 C-34.06101411 69.58645382 -36.96437683 66.66847561 -39.86636353 63.74836731 C-41.13348472 62.50104607 -41.13348472 62.50104607 -42.42620432 61.22852641 C-51.95179632 51.56695959 -56.26775706 42.58569636 -56.24658203 29.14257812 C-56.07334123 18.67218869 -52.62363806 11.71604526 -45.3359375 4.30859375 C-32.79002916 -7.12021316 -14.52141314 -8.71806219 0 0 Z " fill="${color}" transform="translate(56,115)"/>
//</svg>`
//                    let xSvg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="512" height="512">
//<path d="M0 0 C6.06920939 4.16947962 11.26534753 8.98426979 16.44091797 14.20040894 C17.65786079 15.41478848 17.65786079 15.41478848 18.89938831 16.65370095 C21.60175693 19.35278975 24.29694078 22.05893757 26.9921875 24.76513672 C28.93324236 26.70787171 30.87580872 28.6490928 32.8183136 30.59037781 C36.99196351 34.762982 41.16195299 38.93921521 45.32943726 43.11797714 C51.35482952 49.15966409 57.38577538 55.19578233 63.41806543 61.2305813 C73.20629538 71.02318213 82.9900561 80.82023548 92.77099609 90.62011719 C102.26896987 100.13646548 111.76905423 109.65069864 121.27197266 119.16210938 C121.858309 119.74897116 122.44464534 120.33583295 123.04874945 120.94047843 C125.99041194 123.8847511 128.93211584 126.8289824 131.87384033 129.77319312 C156.25565063 154.17571703 180.63020332 178.58547871 205 203 C208.08133132 201.62669316 210.18494176 200.06166221 212.55929089 197.67563152 C213.25141711 196.9850206 213.94354334 196.29440967 214.65664309 195.58287114 C215.78556907 194.44111392 215.78556907 194.44111392 216.93730164 193.27629089 C217.74291261 192.46956651 218.54852358 191.66284212 219.37854701 190.83167154 C222.0861448 188.11798511 224.78652524 185.39722709 227.48706055 182.67651367 C229.4227345 180.73259217 231.35995622 178.790216 233.29716492 176.8478241 C237.47332738 172.65906163 241.64602851 168.46687683 245.8166256 164.27257347 C251.85439547 158.20084728 257.89958647 152.13655191 263.94700465 146.07443694 C273.76847409 136.22906846 283.58693656 126.38070825 293.40209961 116.52905273 C293.98961853 115.93935356 294.57713746 115.3496544 295.18245999 114.74208555 C303.51413838 106.37920754 311.84281524 98.01334664 320.17027835 89.64627144 C320.75628132 89.05748185 321.34228429 88.46869225 321.94604492 87.86206055 C322.53133052 87.27398789 323.11661613 86.68591522 323.71963765 86.08002218 C333.48826152 76.26528489 343.26463397 66.45830821 353.04735976 56.65762693 C359.07844465 50.61485091 365.10294079 44.56565153 371.11906306 38.50797806 C375.24536308 34.35420318 379.37890658 30.20772937 383.51815905 26.06686183 C385.90418752 23.67942916 388.2856389 21.28786188 390.66065216 18.88944244 C393.24050725 16.28515408 395.83248703 13.69355094 398.42778015 11.10466003 C399.53997572 9.97294106 399.53997572 9.97294106 400.67463988 8.81835908 C408.35381502 1.21248163 417.1126541 -4.23742427 428.1875 -4.375 C437.23930085 -4.22018015 446.42865917 -1.50830638 453 5 C461.18169094 14.98869017 462.87107911 23.47911325 462.1953125 36.03710938 C461.09405247 47.10477269 451.25126172 56.04720294 443.79959106 63.44091797 C442.58521152 64.65786079 442.58521152 64.65786079 441.34629905 65.89938831 C438.64721025 68.60175693 435.94106243 71.29694078 433.23486328 73.9921875 C431.29212829 75.93324236 429.3509072 77.87580872 427.40962219 79.8183136 C423.237018 83.99196351 419.06078479 88.16195299 414.88202286 92.32943726 C408.84033591 98.35482952 402.80421767 104.38577538 396.7694187 110.41806543 C386.97681787 120.20629538 377.17976452 129.9900561 367.37988281 139.77099609 C357.86353452 149.26896987 348.34930136 158.76905423 338.83789062 168.27197266 C338.25102884 168.858309 337.66416705 169.44464534 337.05952157 170.04874945 C334.1152489 172.99041194 331.1710176 175.93211584 328.22680688 178.87384033 C303.82428297 203.25565063 279.41452129 227.63020332 255 252 C259.45239435 257.33523764 264.15771505 262.28660138 269.09083557 267.17744446 C270.28767272 268.3702715 270.28767272 268.3702715 271.50868839 269.58719605 C274.17082657 272.23930976 276.83653507 274.88780565 279.50219727 277.53637695 C281.41638065 279.44208892 283.33034522 281.34801795 285.24398804 283.25427246 C288.8273583 286.82328465 292.4116766 290.39134025 295.99712037 293.95826938 C303.04320476 300.9679896 310.08301294 307.9839829 317.12059021 315.00224304 C318.23050706 316.10904961 319.3404276 317.21585247 320.45035177 318.32265168 C322.13208959 319.99966402 323.81382378 321.67667999 325.49554323 323.35371074 C331.82663864 329.66710458 338.15842682 335.97980315 344.4909668 342.29174805 C345.06943212 342.86833631 345.64789744 343.44492458 346.24389201 344.03898522 C355.62064189 353.38483683 365.00473931 362.72328103 374.39110363 372.05947516 C384.04066054 381.65789331 393.68060343 391.2658938 403.31215328 400.88238114 C409.24643666 406.80671528 415.18827476 412.72325917 421.14014959 418.62992074 C425.21952282 422.67966423 429.28963797 426.73856192 433.35268158 430.80468789 C435.69437687 433.14759789 438.04112506 435.4847619 440.3965168 437.81394768 C442.95481152 440.34503961 445.49712088 442.89120579 448.03614807 445.44160461 C448.77622606 446.16643628 449.51630406 446.89126794 450.27880865 447.63806421 C458.77947072 456.2545276 462.36230695 465.23244648 462.45532227 477.23779297 C462.26398075 486.25654689 458.76541324 493.26482071 452.75 499.9375 C451.536889 501.00190707 450.28515838 502.02379888 449 503 C448.35160156 503.5053125 447.70320313 504.010625 447.03515625 504.53125 C438.82778436 509.72396332 428.33641532 509.16245521 419 508 C403.89342904 504.10213169 390.8329941 485.96870529 380.23974609 475.35327148 C378.3468841 473.4601271 376.4538242 471.56718256 374.56051636 469.67448425 C370.50040279 465.61489242 366.44210912 461.55348879 362.38508224 457.4908123 C356.51946014 451.6170274 350.65104472 445.74603968 344.7819664 439.87570847 C335.2574694 430.34902843 325.7352029 420.82012219 316.21435547 411.28979492 C306.97139374 402.03763968 297.72737151 392.78654612 288.48193359 383.53686523 C287.62561972 382.68015728 287.62561972 382.68015728 286.75200658 381.80614208 C283.88778849 378.94061887 281.02354968 376.07511637 278.15930057 373.20962417 C254.43631954 349.47629383 230.7169654 325.73934182 207 302 C203.92788644 303.37030026 201.82669982 304.92665902 199.4591198 307.30595779 C198.77109366 307.99246863 198.08306753 308.67897946 197.37419212 309.38629365 C196.25212574 310.52119127 196.25212574 310.52119127 195.10739136 311.67901611 C194.3065695 312.48095138 193.50574764 313.28288665 192.68065846 314.10912299 C189.98921393 316.80665602 187.30498728 319.51126027 184.62060547 322.21582031 C182.69640621 324.14826727 180.77065906 326.0791688 178.84492493 328.01008606 C174.69331965 332.17429161 170.5451759 336.34191946 166.39913559 340.51166534 C160.39578573 346.5489764 154.3850107 352.57885254 148.37200917 358.60654923 C138.60492811 368.39753021 128.84085324 378.19150207 119.08007812 387.98876953 C118.49581213 388.57521578 117.91154613 389.16166202 117.3095751 389.76587936 C109.02635318 398.0802925 100.74613641 406.39769201 92.4671389 414.71631131 C91.88469205 415.30154479 91.3022452 415.88677827 90.70214844 416.48974609 C89.82954863 417.36652649 89.82954863 417.36652649 88.93932055 418.26101962 C79.2260716 428.02040019 69.50505935 437.77200536 59.77769578 447.51731753 C53.78192612 453.52477177 47.7927397 459.53864263 41.81194885 465.56101003 C37.7085471 469.69191035 33.59787897 473.81548636 29.48151211 477.933467 C27.10953528 480.30684648 24.74212358 482.68434571 22.3811779 485.06872749 C19.81483228 487.65955196 17.23631327 490.23764086 14.6545105 492.81304932 C13.91985058 493.56072484 13.18519066 494.30840037 12.42826831 495.07873273 C2.65142998 504.76205327 -5.78266897 508.34432101 -19.30761719 508.3828125 C-28.70296616 508.2204154 -34.34235113 505.61347579 -41.3125 499.375 C-48.4859471 491.53222517 -50.72807716 483.62148696 -50.51733398 473.20507812 C-49.52534889 453.72292685 -31.05663402 440.91645828 -18.16967773 428.05615234 C-16.25655002 426.14386583 -14.34418029 424.23082195 -12.43177795 422.31781006 C-8.32962431 418.21513464 -4.22565859 414.11427932 -0.12042046 410.0146904 C5.81490234 404.08752983 11.74742851 398.15757648 17.67929792 392.22696002 C27.30580659 382.60263447 36.93454156 372.98053948 46.56469727 363.35986328 C55.9138576 354.01989623 65.26195644 344.67886884 74.60864258 335.33642578 C75.18575521 334.75957587 75.76286784 334.18272597 76.35746873 333.58839576 C79.25296009 330.69420953 82.14843073 327.80000258 85.04389107 324.90578532 C109.02604978 300.93397619 133.01183018 276.96579391 157 253 C152.55649188 247.67774497 147.86471116 242.73141687 142.9471283 237.84706116 C142.15332042 237.05451555 141.35951254 236.26196995 140.54164988 235.44540781 C137.89333257 232.8024484 135.24145409 230.16309159 132.58959961 227.52368164 C130.68528346 225.62456123 128.7811784 223.72523157 126.87736511 221.8256073 C122.78316415 217.74109094 118.68729485 213.65825394 114.59043694 209.57640266 C108.11166442 203.12106807 101.63813353 196.66049101 95.16542053 190.19908142 C92.94786682 187.98552851 90.73027917 185.77200961 88.51268101 183.55850124 C87.68154114 182.72889022 87.68154114 182.72889022 86.83361058 181.88251938 C80.53537634 175.59601299 74.23606589 169.3105855 67.9362793 163.02563477 C67.36080459 162.45151249 66.78532989 161.87739022 66.19241656 161.28587031 C56.86138799 151.97703464 47.52652754 142.67204884 38.19070178 133.36802465 C28.59458292 123.80431387 19.0042455 114.23483106 9.41881377 104.66040891 C3.51203035 98.76083986 -2.39943632 92.86604355 -8.31705415 86.97734176 C-12.37195457 82.94146429 -16.42135659 78.900124 -20.46651179 74.85447914 C-22.79850804 72.52254579 -25.13367846 70.19395648 -27.47389221 67.87026596 C-30.01429942 65.34704908 -32.54525572 62.81470851 -35.07411194 60.27992249 C-35.81029898 59.55315609 -36.54648603 58.82638969 -37.30498177 58.07760006 C-46.50515831 48.80516866 -50.40830501 40.42549585 -50.36791992 27.40478516 C-50.23352583 21.50800549 -49.22417303 17.0165587 -46 12 C-45.649375 11.37996094 -45.29875 10.75992187 -44.9375 10.12109375 C-40.61757544 3.17621502 -33.26861138 -1.2666089 -25.51171875 -3.52734375 C-16.52198457 -5.21903556 -7.98080302 -4.64202228 0 0 Z " fill="${color}" transform="translate(50,4)"/>
//</svg>`

//                    let vectorRUnMasterAdmin = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="500" height="500">
//<path d="M0 0 C5.48057841 3.02942208 10.69946401 6.50721467 15.9375 9.93359375 C19.21700413 12.04129393 22.54420965 13.93800939 25.96875 15.79296875 C30.41011519 18.2646189 34.69748501 20.98834863 39.00878906 23.67822266 C41.73173572 25.36004265 44.47182743 27.01260842 47.2109375 28.66796875 C49.37002251 29.98660127 51.52887472 31.30561504 53.6875 32.625 C54.73043213 33.25003418 55.77336426 33.87506836 56.84790039 34.51904297 C68.08109395 41.42968405 68.08109395 41.42968405 71.25 47.0625 C72.72003333 54.07282023 72.08342159 61.33061144 68.33203125 67.5078125 C67.97496094 68.02085937 67.61789062 68.53390625 67.25 69.0625 C66.71375 69.8875 66.1775 70.7125 65.625 71.5625 C65.17125 72.0575 64.7175 72.5525 64.25 73.0625 C63.59 73.0625 62.93 73.0625 62.25 73.0625 C62.25 73.7225 62.25 74.3825 62.25 75.0625 C61.59 75.0625 60.93 75.0625 60.25 75.0625 C60.25 75.7225 60.25 76.3825 60.25 77.0625 C59.59 77.0625 58.93 77.0625 58.25 77.0625 C58.00636719 77.63484375 57.76273438 78.2071875 57.51171875 78.796875 C56.02482702 81.46683538 54.26916092 83.20079007 52.0625 85.3125 C48.5017119 88.78782918 45.1868106 92.36295491 41.953125 96.140625 C39.63296025 98.75879256 37.15031605 101.18999798 34.6328125 103.6171875 C33.14145515 105.03359777 33.14145515 105.03359777 32.25 107.0625 C31.59 107.0625 30.93 107.0625 30.25 107.0625 C30.25 107.7225 30.25 108.3825 30.25 109.0625 C29.59 109.0625 28.93 109.0625 28.25 109.0625 C28.25 109.7225 28.25 110.3825 28.25 111.0625 C27.59 111.0625 26.93 111.0625 26.25 111.0625 C26.25 111.7225 26.25 112.3825 26.25 113.0625 C25.59 113.0625 24.93 113.0625 24.25 113.0625 C24.25 113.7225 24.25 114.3825 24.25 115.0625 C23.59 115.0625 22.93 115.0625 22.25 115.0625 C22.25 115.7225 22.25 116.3825 22.25 117.0625 C21.59 117.0625 20.93 117.0625 20.25 117.0625 C20.25 117.7225 20.25 118.3825 20.25 119.0625 C19.59 119.0625 18.93 119.0625 18.25 119.0625 C18.25 120.0525 18.25 121.0425 18.25 122.0625 C26.2677551 126.34316586 34.27985979 130.61578433 42.4375 134.625 C47.37461878 137.08210436 52.24596558 139.62828872 57.0625 142.3125 C57.66795654 142.64193604 58.27341309 142.97137207 58.8972168 143.31079102 C63.13293184 145.71129551 63.13293184 145.71129551 64.25 149.0625 C64.91 149.0625 65.57 149.0625 66.25 149.0625 C69.58356502 153.19612063 70.42235634 157.85898011 70.25 163.0625 C69.06852166 169.12742212 66.47678381 173.00549965 62.75 177.75 C62.21536133 178.44697998 61.68072266 179.14395996 61.12988281 179.86206055 C57.06998353 185.11764233 52.83364276 190.2090277 48.54296875 195.27734375 C45.66197432 198.77674584 43.03527506 202.42294894 40.40625 206.11328125 C37.33021816 210.32053495 34.09190058 214.3944713 30.84204102 218.46826172 C28.30896465 221.60858921 28.30896465 221.60858921 26.25 225.0625 C25.59 225.0625 24.93 225.0625 24.25 225.0625 C24.0128125 225.75730469 23.775625 226.45210937 23.53125 227.16796875 C22.0189473 230.58448185 19.99761633 233.42006671 17.75 236.375 C17.34652344 236.92478516 16.94304687 237.47457031 16.52734375 238.04101562 C15.48731309 239.42257451 14.37366546 240.74806298 13.25 242.0625 C12.59 242.0625 11.93 242.0625 11.25 242.0625 C10.88261719 243.14144531 10.88261719 243.14144531 10.5078125 244.2421875 C7.80061144 250.31237125 2.49293655 256.54369886 -3.6875 259.25 C-9.60669899 260.90077263 -15.99575505 260.16634009 -21.5625 257.625 C-26.05680251 254.70689837 -28.01790862 249.96882051 -29.75 245.0625 C-30.93045308 238.45196275 -28.17807398 233.55503631 -24.75 228.0625 C-22.32559342 224.6402368 -19.73846718 221.34919577 -17.125 218.0703125 C-15.23445326 215.67603456 -13.46402821 213.27002957 -11.75 210.75 C-11.09 209.863125 -10.43 208.97625 -9.75 208.0625 C-9.09 208.0625 -8.43 208.0625 -7.75 208.0625 C-7.49089844 207.32902344 -7.23179687 206.59554687 -6.96484375 205.83984375 C-5.70994739 202.97093278 -4.31205767 201.02363779 -2.3125 198.625 C-1.60222656 197.75875 -0.89195312 196.8925 -0.16015625 196 C0.63519531 195.030625 1.43054688 194.06125 2.25 193.0625 C4.09533877 190.75940806 5.92495554 188.44419578 7.75 186.125 C8.21438477 185.53517334 8.67876953 184.94534668 9.15722656 184.33764648 C13.3287545 179.01215172 17.32528218 173.57284881 21.25 168.0625 C18.61288988 165.98144953 16.07013201 164.37705157 13.01953125 162.9765625 C12.21580078 162.60273438 11.41207031 162.22890625 10.58398438 161.84375 C9.33584961 161.27140625 9.33584961 161.27140625 8.0625 160.6875 C2.32858612 158.05017244 -3.26636001 155.29709428 -8.76049805 152.1875 C-11.16897962 150.82558037 -13.61577057 149.54165461 -16.0625 148.25 C-25.56594613 143.05656747 -33.67670662 138.17244008 -39.75 129.0625 C-41.20839207 122.27494591 -41.43397299 116.08373683 -37.75 110.0625 C-35.52570172 107.11438984 -33.21486835 104.28186234 -30.80859375 101.48046875 C-28.65403063 99.04531695 -28.65403063 99.04531695 -26.75 96.0625 C-26.09 96.0625 -25.43 96.0625 -24.75 96.0625 C-24.5025 95.34707031 -24.255 94.63164062 -24 93.89453125 C-22.61136405 90.74840294 -20.90536054 88.42439037 -18.75 85.75 C-17.698125 84.42548828 -17.698125 84.42548828 -16.625 83.07421875 C-16.00625 82.41035156 -15.3875 81.74648437 -14.75 81.0625 C-14.09 81.0625 -13.43 81.0625 -12.75 81.0625 C-12.4921875 80.50046875 -12.234375 79.9384375 -11.96875 79.359375 C-10.60830223 76.79545421 -9.02211038 74.61023635 -7.25 72.3125 C-6.6415625 71.51328125 -6.033125 70.7140625 -5.40625 69.890625 C-4.8596875 69.28734375 -4.313125 68.6840625 -3.75 68.0625 C-3.09 68.0625 -2.43 68.0625 -1.75 68.0625 C-1.51539063 67.51851563 -1.28078125 66.97453125 -1.0390625 66.4140625 C1.18383727 62.35895443 4.36683828 59.03543161 7.3515625 55.5234375 C9.45360115 53.31658905 9.45360115 53.31658905 9.25 51.0625 C7.81674374 49.86831591 7.81674374 49.86831591 5.92578125 48.75 C5.22646484 48.31429687 4.52714844 47.87859375 3.80664062 47.4296875 C2.69579102 46.75292969 2.69579102 46.75292969 1.5625 46.0625 C0.84126953 45.61132812 0.12003906 45.16015625 -0.62304688 44.6953125 C-2.64562554 43.44667033 -4.69015512 42.24833365 -6.75 41.0625 C-7.5853125 40.55976563 -8.420625 40.05703125 -9.28125 39.5390625 C-13.22732849 38.7773195 -16.14515536 40.66183619 -19.5625 42.4375 C-20.30806152 42.80673584 -21.05362305 43.17597168 -21.82177734 43.55639648 C-24.13989204 44.70860852 -26.4450934 45.88412946 -28.75 47.0625 C-30.13068383 47.7555554 -31.51216313 48.44702896 -32.89453125 49.13671875 C-34.87775885 50.1266412 -36.86035041 51.11761878 -38.83984375 52.11499023 C-43.547184 54.48331219 -48.28868875 56.76877476 -53.0625 59 C-54.00536865 59.44194702 -54.00536865 59.44194702 -54.96728516 59.89282227 C-61.51266102 62.93090891 -67.83167749 64.55711391 -74.9609375 62.390625 C-76.58999302 61.68580914 -78.17632131 60.88354975 -79.75 60.0625 C-79.75 59.4025 -79.75 58.7425 -79.75 58.0625 C-80.41 58.0625 -81.07 58.0625 -81.75 58.0625 C-85.20621426 52.15348852 -87.33016603 48.14052561 -86.75 41.0625 C-84.67089058 33.91204935 -79.96203203 29.8258739 -73.75 26.0625 C-68.82025661 23.4870734 -63.74950798 21.21290563 -58.67675781 18.93652344 C-56.31822509 17.86663657 -53.99910973 16.73005881 -51.6875 15.5625 C-50.92566406 15.17835938 -50.16382813 14.79421875 -49.37890625 14.3984375 C-47.93154631 13.66292918 -46.4844558 12.92688684 -45.03857422 12.18847656 C-40.29642371 9.77013939 -35.53386826 7.39722135 -30.75 5.0625 C-30.04939453 4.71799805 -29.34878906 4.37349609 -28.62695312 4.01855469 C-10.44844079 -4.8184557 -10.44844079 -4.8184557 0 0 Z " fill="${secondaryIconColor}" transform="translate(274.75,134.9375)"/>
//<path d="M0 0 C0.99 0 1.98 0 3 0 C3.17015625 0.71285156 3.3403125 1.42570312 3.515625 2.16015625 C6.2804811 13.08722051 9.4906093 18.65482557 19 25 C19.73605469 25.35449219 20.47210938 25.70898438 21.23046875 26.07421875 C23 27 23 27 23.8125 29 C24 31 24 31 23 33 C22.34 33 21.68 33 21 33 C20.77441406 33.54398437 20.54882812 34.08796875 20.31640625 34.6484375 C18.58776213 37.73640119 16.35449856 40.04454974 13.9375 42.625 C10.58466353 46.04209753 10.58466353 46.04209753 8 50 C7.34 50 6.68 50 6 50 C6 50.66 6 51.32 6 52 C5.34 52 4.68 52 4 52 C3.68095703 52.79857422 3.68095703 52.79857422 3.35546875 53.61328125 C1.48242494 56.91134975 -1.08089841 59.46748139 -3.6875 62.1875 C-8.00390423 66.75533897 -12.01100262 71.38340413 -15.6953125 76.48828125 C-16.12585938 76.98714844 -16.55640625 77.48601562 -17 78 C-17.66 78 -18.32 78 -19 78 C-19.27602051 78.59441895 -19.55204102 79.18883789 -19.83642578 79.80126953 C-20.93794952 81.88274724 -22.06503249 83.42210824 -23.6171875 85.1796875 C-24.39461304 86.06744873 -24.39461304 86.06744873 -25.18774414 86.97314453 C-25.74453857 87.60075684 -26.30133301 88.22836914 -26.875 88.875 C-28.0590576 90.22355121 -29.24264091 91.57251897 -30.42578125 92.921875 C-31.02471191 93.60314453 -31.62364258 94.28441406 -32.24072266 94.98632812 C-34.38163352 97.43681838 -36.48933385 99.91413758 -38.59399414 102.39575195 C-43.12667208 107.73323456 -47.72855537 113.00466716 -52.4375 118.1875 C-53.1636853 118.99888428 -53.1636853 118.99888428 -53.90454102 119.82666016 C-58.72022428 125.07023669 -62.70758023 127.44870443 -69.73046875 127.99609375 C-76.28685641 128.00737841 -80.41093017 125.48477279 -85 121 C-88.0811925 117.06882337 -89.1424369 112.95858463 -89 108 C-87.79015134 101.72391007 -85.05111848 96.88211715 -81 92 C-80.34 92 -79.68 92 -79 92 C-78.77441406 91.45601563 -78.54882812 90.91203125 -78.31640625 90.3515625 C-76.58776213 87.26359881 -74.35449856 84.95545026 -71.9375 82.375 C-68.58466353 78.95790247 -68.58466353 78.95790247 -66 75 C-65.34 75 -64.68 75 -64 75 C-63.77441406 74.45601563 -63.54882812 73.91203125 -63.31640625 73.3515625 C-61.58776213 70.26359881 -59.35449856 67.95545026 -56.9375 65.375 C-53.58466353 61.95790247 -53.58466353 61.95790247 -51 58 C-50.34 58 -49.68 58 -49 58 C-48.75636719 57.43796875 -48.51273438 56.8759375 -48.26171875 56.296875 C-46.75819064 53.55980215 -44.93300252 51.54204059 -42.8125 49.25 C-42.00683594 48.36957031 -41.20117188 47.48914063 -40.37109375 46.58203125 C-39.19740234 45.30392578 -39.19740234 45.30392578 -38 44 C-33.56306443 39.0710839 -29.42049945 34.02502442 -25.48046875 28.6875 C-24.99191406 28.130625 -24.50335938 27.57375 -24 27 C-23.34 27 -22.68 27 -22 27 C-21.77441406 26.45601563 -21.54882812 25.91203125 -21.31640625 25.3515625 C-19.58776213 22.26359881 -17.35449856 19.95545026 -14.9375 17.375 C-11.58466353 13.95790247 -11.58466353 13.95790247 -9 10 C-8.34 10 -7.68 10 -7 10 C-6.773125 9.46375 -6.54625 8.9275 -6.3125 8.375 C-4.53064818 5.15069671 -2.51917702 2.70350705 0 0 Z " fill="${secondaryIconColor}" transform="translate(227,255)"/>
//<path d="M0 0 C3.95026722 3.66600481 5.69553906 7.02027575 6.23828125 12.33203125 C6.26277344 13.15058594 6.28726563 13.96914062 6.3125 14.8125 C6.36857422 16.02873047 6.36857422 16.02873047 6.42578125 17.26953125 C5.24928688 24.81420616 -0.4010834 29.83867719 -5.625 34.9375 C-6.305625 35.62134766 -6.98625 36.30519531 -7.6875 37.00976562 C-12.73257212 42 -12.73257212 42 -15 42 C-15 42.66 -15 43.32 -15 44 C-15.66 44 -16.32 44 -17 44 C-17 44.66 -17 45.32 -17 46 C-17.66 46 -18.32 46 -19 46 C-19 46.66 -19 47.32 -19 48 C-19.66 48 -20.32 48 -21 48 C-21 48.66 -21 49.32 -21 50 C-21.66 50 -22.32 50 -23 50 C-23 50.66 -23 51.32 -23 52 C-23.66 52 -24.32 52 -25 52 C-25.268125 52.639375 -25.53625 53.27875 -25.8125 53.9375 C-27 56 -27 56 -30 57 C-30 57.66 -30 58.32 -30 59 C-31.4621582 60.43652344 -31.4621582 60.43652344 -33.48828125 62.109375 C-38.732029 66.5667338 -43.47570037 71.45401468 -48.26367188 76.390625 C-56.85017324 85.11761773 -56.85017324 85.11761773 -63.375 85.8125 C-64.08398438 85.90144531 -64.79296875 85.99039063 -65.5234375 86.08203125 C-72.3405823 85.85622677 -77.5114095 82.77378968 -83.0625 79.1875 C-83.74376953 78.76146484 -84.42503906 78.33542969 -85.12695312 77.89648438 C-89.36571513 75.20501302 -93.21020309 72.29316205 -97 69 C-96.40312566 65.65750371 -95.26396123 63.53563658 -93 61 C-92.34 61 -91.68 61 -91 61 C-90.72027344 60.41089844 -90.44054687 59.82179687 -90.15234375 59.21484375 C-89.08884935 57.17077145 -87.89932926 55.43239513 -86.5625 53.5625 C-83.1211645 48.19686744 -82.15995287 42.18641531 -81 36 C-76.18285158 37.51474072 -72.30695748 39.41582551 -68 42 C-67.51789063 41.4946875 -67.03578125 40.989375 -66.5390625 40.46875 C-65.90742188 39.8190625 -65.27578125 39.169375 -64.625 38.5 C-63.99851562 37.8503125 -63.37203125 37.200625 -62.7265625 36.53125 C-61 35 -61 35 -59 35 C-59 34.34 -59 33.68 -59 33 C-58.34 33 -57.68 33 -57 33 C-57 32.34 -57 31.68 -57 31 C-56.34 31 -55.68 31 -55 31 C-55 30.34 -55 29.68 -55 29 C-54.34 29 -53.68 29 -53 29 C-53 28.34 -53 27.68 -53 27 C-52.34 27 -51.68 27 -51 27 C-51 26.34 -51 25.68 -51 25 C-50.34 25 -49.68 25 -49 25 C-48.731875 24.401875 -48.46375 23.80375 -48.1875 23.1875 C-47.00082594 21.00152146 -45.90400887 19.58667406 -44 18 C-43.34 18 -42.68 18 -42 18 C-42 17.34 -42 16.68 -42 16 C-41.34 16 -40.68 16 -40 16 C-40 15.34 -40 14.68 -40 14 C-39.34 14 -38.68 14 -38 14 C-38 13.34 -38 12.68 -38 12 C-37.34 12 -36.68 12 -36 12 C-36 11.34 -36 10.68 -36 10 C-35.34 10 -34.68 10 -34 10 C-34 9.34 -34 8.68 -34 8 C-33.34 8 -32.68 8 -32 8 C-32 7.34 -32 6.68 -32 6 C-30.31038731 4.4123467 -28.54682629 2.90271306 -26.75 1.4375 C-25.77546875 0.63183594 -24.8009375 -0.17382812 -23.796875 -1.00390625 C-16.48932427 -6.21921131 -7.11609014 -5.05412938 0 0 Z " fill="${secondaryIconColor}" transform="translate(432,151)"/>
//<path d="M0 0 C6.75480539 6.22616845 10.5655715 14.32361398 11.1875 23.44921875 C11.32940628 33.15797325 10.27462404 41.75812214 3.984375 49.46875 C3.324375 49.46875 2.664375 49.46875 1.984375 49.46875 C1.73816406 50.06558594 1.49195313 50.66242188 1.23828125 51.27734375 C-1.9915868 56.92206642 -9.51058917 60.23500481 -15.57421875 61.99609375 C-26.45808782 64.1032108 -35.36235237 61.42945955 -45.015625 56.46875 C-45.015625 55.80875 -45.015625 55.14875 -45.015625 54.46875 C-45.60214844 54.22253906 -46.18867188 53.97632813 -46.79296875 53.72265625 C-52.13271994 50.71024829 -55.84254046 44.70131655 -57.890625 39.03125 C-60.71247823 28.8373052 -60.57895441 19.59540883 -55.7578125 9.953125 C-49.90452397 0.54948113 -42.04695757 -5.12185023 -31.515625 -8.28125 C-19.91427537 -9.44138496 -9.41862666 -7.15523576 0 0 Z " fill="${secondaryIconColor}" transform="translate(382.015625,113.53125)"/>
//<path d="M0 0 C0.98756287 -0.00365067 1.97512573 -0.00730133 2.99261475 -0.01106262 C6.25306459 -0.01916045 9.51301626 -0.00556403 12.7734375 0.0090332 C15.04117838 0.0095519 17.30891972 0.00903383 19.57666016 0.00752258 C24.32786782 0.00761227 29.07890569 0.01803522 33.83007812 0.03613281 C39.91992316 0.05881967 46.00952009 0.05936365 52.09939575 0.05261517 C56.78167932 0.04927351 61.46390635 0.05590903 66.1461792 0.0657444 C68.39165959 0.06959327 70.63714627 0.07074591 72.88262939 0.06915855 C76.02083315 0.06878766 79.158719 0.08141536 82.296875 0.09765625 C83.22481873 0.09517883 84.15276245 0.09270142 85.10882568 0.09014893 C89.51559612 0.1265418 93.20453124 0.15852766 97.1484375 2.37231445 C99.54432002 5.24737348 100.17691594 6.67459272 100.0234375 10.43481445 C99.1333836 13.42285255 98.3008681 15.13709807 96.1484375 17.37231445 C93.40261572 18.28758838 91.77715083 18.50143246 88.94900513 18.51275635 C88.09386322 18.51846649 87.23872131 18.52417664 86.35766602 18.53005981 C85.42253174 18.53117767 84.48739746 18.53229553 83.52392578 18.53344727 C82.53665497 18.53841217 81.54938416 18.54337708 80.53219604 18.54849243 C77.26104032 18.56311648 73.98993307 18.56991616 70.71875 18.57543945 C68.44815062 18.5811903 66.17755125 18.58694804 63.9069519 18.5927124 C59.14385756 18.60322281 54.3807801 18.60906535 49.61767578 18.61254883 C43.51205419 18.61803639 37.40665529 18.64207001 31.30110359 18.67052078 C26.61025335 18.68913589 21.9194569 18.69435215 17.22857285 18.6958847 C14.97749488 18.69891384 12.72641791 18.70695112 10.47537613 18.72006989 C7.32732391 18.73710798 4.17981779 18.73525553 1.03173828 18.72875977 C-0.36489044 18.74258194 -0.36489044 18.74258194 -1.78973389 18.75668335 C-6.61498333 18.72546457 -9.97800634 18.58576129 -13.8515625 15.37231445 C-15.99408898 12.15852473 -16.12348708 11.52058265 -15.7890625 7.87231445 C-15.73621094 7.09887695 -15.68335938 6.32543945 -15.62890625 5.52856445 C-14.8515625 3.37231445 -14.8515625 3.37231445 -12.91870117 1.76081848 C-8.5773117 -0.20454319 -4.71347025 -0.0388262 0 0 Z " fill="${secondaryIconColor}" transform="translate(77.8515625,184.627685546875)"/>
//<path d="M0 0 C1.30177689 -0.00960754 2.60355377 -0.01921509 3.94477844 -0.02911377 C5.3683759 -0.03396215 6.7919754 -0.03824088 8.21557617 -0.04199219 C9.67665101 -0.04774641 11.13772584 -0.05350411 12.59880066 -0.05926514 C15.66287589 -0.06976794 18.72692493 -0.07561512 21.79101562 -0.07910156 C25.70839593 -0.08458084 29.62542771 -0.10859945 33.54269886 -0.13707352 C36.56167089 -0.1557416 39.58055972 -0.16090773 42.59958458 -0.16243744 C44.04321889 -0.16545576 45.48685203 -0.17345654 46.93042946 -0.18662262 C48.95485121 -0.20376635 50.97941722 -0.19994607 53.00390625 -0.1953125 C54.15401688 -0.19895813 55.3041275 -0.20260376 56.48908997 -0.20635986 C60.14306435 0.21235784 62.55112419 1.28550237 65.69604492 3.16113281 C67.47884174 5.51118316 67.6971843 7.16878291 68.13354492 10.09863281 C67.53235123 14.30698865 65.9737307 15.52298879 62.69604492 18.16113281 C59.38829041 18.7893219 59.38829041 18.7893219 55.58251953 18.79223633 C54.53767647 18.80296928 54.53767647 18.80296928 53.47172546 18.81391907 C51.17993657 18.83076443 48.89011538 18.81143329 46.59838867 18.79003906 C45.00085794 18.79086807 43.40332729 18.79332864 41.80580139 18.79734802 C38.46255733 18.80020301 35.11998434 18.7855334 31.77685547 18.75805664 C27.49366118 18.72394586 23.21166435 18.73000359 18.92841244 18.74871922 C15.63149549 18.75929136 12.33485684 18.75035008 9.03796577 18.7353344 C7.45873402 18.7301555 5.87947317 18.73063087 4.30024529 18.73687935 C2.09292025 18.74233562 -0.1126942 18.72194827 -2.31982422 18.69458008 C-4.20248741 18.68528221 -4.20248741 18.68528221 -6.1231842 18.67579651 C-9.86933943 18.06965096 -11.03040284 17.13834593 -13.30395508 14.16113281 C-14.38815143 11.14087154 -14.4373914 9.62815993 -13.55395508 6.53613281 C-10.36237761 0.47213563 -6.54369714 0.03892956 0 0 Z " fill="${secondaryIconColor}" transform="translate(116.303955078125,132.8388671875)"/>
//<path d="M0 0 C0.73733368 -0.00150055 1.47466736 -0.0030011 2.23434448 -0.00454712 C4.61201526 -0.00688854 6.98953202 -0.00068426 9.3671875 0.0078125 C10.17365723 0.01002808 10.98012695 0.01224365 11.81103516 0.01452637 C17.28834868 0.03226025 22.76517265 0.07355185 28.2421875 0.1328125 C29.42264648 0.14538086 30.60310547 0.15794922 31.81933594 0.17089844 C34.62866184 0.21422767 37.43420351 0.2877463 40.2421875 0.3828125 C41.02223145 0.39683105 41.80227539 0.41084961 42.60595703 0.42529297 C45.95773583 0.57928326 47.95219637 0.9250851 50.70703125 2.8984375 C52.88883377 6.07398723 52.86602901 8.25149253 52.69921875 12.0078125 C52.2421875 14.1328125 52.2421875 14.1328125 49.9921875 16.6328125 C45.91212934 18.85829877 42.62104551 19.25888853 38.00219727 19.27807617 C36.95753799 19.28445602 35.91287872 19.29083588 34.83656311 19.29740906 C33.15209328 19.29907829 33.15209328 19.29907829 31.43359375 19.30078125 C29.69528542 19.30577385 29.69528542 19.30577385 27.92185974 19.31086731 C25.47159217 19.31592876 23.02131771 19.31827588 20.57104492 19.31811523 C16.8226385 19.32030203 13.07452624 19.33846717 9.32617188 19.35742188 C6.94531351 19.36035588 4.56445374 19.36234063 2.18359375 19.36328125 C0.50216026 19.37405952 0.50216026 19.37405952 -1.21324158 19.38505554 C-2.78495872 19.3804406 -2.78495872 19.3804406 -4.38842773 19.37573242 C-5.30679916 19.37715744 -6.22517059 19.37858246 -7.17137146 19.38005066 C-10.78877864 19.03426234 -13.64316408 17.97428669 -16.54296875 15.78515625 C-18.54414774 13.06329544 -18.22778917 10.56371036 -18.10546875 7.29296875 C-17.7578125 5.1328125 -17.7578125 5.1328125 -16.1328125 2.6328125 C-11.30097134 -0.41887666 -5.55808151 -0.01574802 0 0 Z " fill="${secondaryIconColor}" transform="translate(106.7578125,235.8671875)"/>
//</svg>`
//                    let loginIcon = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="99" height="82">
//<path d="M0 0 C3.81143834 3.30952053 6.65033797 7.09213808 8 12 C8.04125 13.175625 8.0825 14.35125 8.125 15.5625 C8.59084394 19.00279092 8.59084394 19.00279092 10.69921875 20.125 C12.12564088 20.75779355 13.55681487 21.37996763 14.9921875 21.9921875 C18.28961881 23.64731839 19.45071129 25.71550794 21 29 C22.21955099 33.64106903 22.25100769 37.11409051 20.9375 41.75 C18.51680433 45.81052177 15.83216679 49.01089186 11.19921875 50.62890625 C8.35653262 51.10857798 5.63132548 51.09381876 2.75 51.0625 C1.13351563 51.04896484 1.13351563 51.04896484 -0.515625 51.03515625 C-1.33546875 51.02355469 -2.1553125 51.01195312 -3 51 C-3 49.68 -3 48.36 -3 47 C-2.04738281 46.91363281 -1.09476563 46.82726563 -0.11328125 46.73828125 C1.14097656 46.59777344 2.39523438 46.45726562 3.6875 46.3125 C4.92886719 46.18488281 6.17023438 46.05726562 7.44921875 45.92578125 C11.66647099 44.82623364 13.28562028 43.35394599 16 40 C17.336095 36.07522093 17.25100055 34.5674795 15.5625 30.75 C15.046875 29.8425 14.53125 28.935 14 28 C14 27.34 14 26.68 14 26 C10.7 25.01 7.4 24.02 4 23 C3.83564453 21.78763672 3.83564453 21.78763672 3.66796875 20.55078125 C3.50941406 19.48214844 3.35085937 18.41351562 3.1875 17.3125 C2.96126953 15.72888672 2.96126953 15.72888672 2.73046875 14.11328125 C1.58266998 9.22132605 -0.05035569 6.6837439 -4.125 3.75 C-9.6591433 0.88952509 -14.77902231 0.37072299 -20.75 2.0625 C-25.63272941 4.97335792 -28.75867512 8.70232302 -31 14 C-31.721875 13.690625 -32.44375 13.38125 -33.1875 13.0625 C-38.07077517 11.21580134 -38.07077517 11.21580134 -43.1875 11.4375 C-45.42245076 13.03794561 -45.42245076 13.03794561 -45.75 16.875 C-46.17578125 19.046875 -46.17578125 19.046875 -47 21 C-48.95549751 22.31218569 -50.91735437 23.11666388 -53.08984375 24.015625 C-56.20514893 25.62105834 -56.96340706 27.76064706 -58 31 C-58.5657935 34.87972683 -58.17230438 36.64849907 -56.4375 40.1875 C-51.69404518 45.6607171 -45.85355843 46.39881066 -39 47 C-39 48.32 -39 49.64 -39 51 C-46.87563115 51.42785119 -52.53746926 50.92391484 -58.8125 45.625 C-62.67664865 40.98802162 -63.41293351 37.12493562 -63.24609375 31.20703125 C-62.70334029 26.33948038 -60.55128171 23.28881389 -56.9375 20.1875 C-54 18 -54 18 -52 17 C-51.37302242 15.72894545 -50.79612773 14.4328322 -50.25 13.125 C-48.77749547 10.10961388 -48.02198777 9.01649082 -45.25 6.9375 C-42 6 -42 6 -38.125 6.8125 C-36.07627825 7.28630667 -36.07627825 7.28630667 -34 7 C-31.7320904 5.19537933 -29.93148806 3.17345931 -28 1.015625 C-20.27822072 -6.76648068 -8.75881814 -5.00922375 0 0 Z " fill="${secondaryIconColor}" transform="translate(70,10)"/>
//<path d="M0 0 C2.5 1.5 2.5 1.5 4 4 C4.59919008 6.99595038 4.86965938 9.95002941 5 13 C7.475 13.495 7.475 13.495 10 14 C10.05789006 17.45826342 10.09355821 20.91640293 10.125 24.375 C10.14175781 25.35984375 10.15851563 26.3446875 10.17578125 27.359375 C10.18222656 28.30039063 10.18867187 29.24140625 10.1953125 30.2109375 C10.20578613 31.08024902 10.21625977 31.94956055 10.22705078 32.84521484 C10 35 10 35 8 37 C5.32617187 37.25878906 5.32617187 37.25878906 1.96875 37.265625 C0.76605469 37.26820312 -0.43664062 37.27078125 -1.67578125 37.2734375 C-2.93777344 37.26570313 -4.19976562 37.25796875 -5.5 37.25 C-6.76199219 37.25773437 -8.02398437 37.26546875 -9.32421875 37.2734375 C-10.52691406 37.27085938 -11.72960937 37.26828125 -12.96875 37.265625 C-14.07669922 37.26336914 -15.18464844 37.26111328 -16.32617188 37.25878906 C-19 37 -19 37 -21 35 C-21.22705078 32.84521484 -21.22705078 32.84521484 -21.1953125 30.2109375 C-21.18886719 29.26992187 -21.18242188 28.32890625 -21.17578125 27.359375 C-21.15902344 26.37453125 -21.14226563 25.3896875 -21.125 24.375 C-21.11597656 23.38242187 -21.10695312 22.38984375 -21.09765625 21.3671875 C-21.07404116 18.91121866 -21.04110799 16.45572832 -21 14 C-19.35 13.67 -17.7 13.34 -16 13 C-16.103125 11.96875 -16.20625 10.9375 -16.3125 9.875 C-15.90324992 4.80029899 -14.53727317 3.53727317 -11 0 C-7.49586172 -1.75206914 -3.72705919 -0.82897224 0 0 Z M-9.6875 5.1875 C-12.5292545 8.03683325 -12.5292545 8.03683325 -12 13 C-7.71 13 -3.42 13 1 13 C0.74831259 8.04591382 0.74831259 8.04591382 -1.875 4.0625 C-5.45446964 2.27276518 -6.59584352 2.67103542 -9.6875 5.1875 Z M-17 17 C-17 22.28 -17 27.56 -17 33 C-9.41 33 -1.82 33 6 33 C6 27.72 6 22.44 6 17 C-1.59 17 -9.18 17 -17 17 Z " fill="${secondaryIconColor}" transform="translate(55,39)"/>
//<path d="M0 0 C2.0625 0.4375 2.0625 0.4375 4 1 C3.67 3.31 3.34 5.62 3 8 C1.68 7.67 0.36 7.34 -1 7 C-1.04254356 5.00045254 -1.04080783 2.99958364 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z " fill="${secondaryIconColor}" transform="translate(48,60)"/>
//</svg>`
//                    const encodedDownSVG = encodeURIComponent(downArrowsvg);
//                    const encodedUpSVG = encodeURIComponent(upArrow);
//                    const encodedXSVG = encodeURIComponent(xSvg);
//                    const encodedvectorRunIcon = encodeURIComponent(vectorRUnMasterAdmin);
//                    const encodedloginIcon = encodeURIComponent(loginIcon);
//                    setItem('Branding', JSON.stringify({
//                        OrgId: urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId"),
//                        BackGround: payload.BackGround,
//                        PrimaryText: payload.PrimaryText,
//                        SecondaryText: payload.SecondaryText,
//                        SecondaryIcon: payload.SecondaryIcon,
//                        ButtonBack: payload.ButtonBack,
//                        ButtonText: payload.ButtonText,
//                        HeaderBack: payload.HeaderBack,
//                        HeaderText: payload.HeaderText,
//                        Domain: payload.Domain,
//                        DomainResellerId: "",
//                        downArrow: `url('data:image/svg+xml,${encodedDownSVG}')`,
//                        upArrow: `url('data:image/svg+xml,${encodedUpSVG}')`,
//                        closeIcon: `url('data:image/svg+xml,${encodedXSVG}')`,
//                        vectorRunIcon: `url('data:image/svg+xml,${encodedvectorRunIcon}')`,
//                        loginIcon: `url('data:image/svg+xml,${encodedloginIcon}')`,
//                        Logo: payload.Logo,
//                        Splash: payload.Splash
//                    }));
//                    const sanitizedSplash = payload.Splash.replace(/\s/g, '');
//                    const sanitizedLogo = payload.Logo.replace(/\s/g, '');
//                    document.documentElement.style.setProperty("--background", payload.BackGround);
//                    document.documentElement.style.setProperty("--primary-text", payload.PrimaryText);
//                    document.documentElement.style.setProperty("--secondary-text", payload.SecondaryText);
//                    document.documentElement.style.setProperty("--secondary-icon", payload.SecondaryIcon);
//                    document.documentElement.style.setProperty("--button-back", payload.ButtonBack);
//                    document.documentElement.style.setProperty("--button-text", payload.ButtonText);
//                    document.documentElement.style.setProperty("--header-back", payload.HeaderBack);
//                    document.documentElement.style.setProperty("--header-text", payload.HeaderText);
//                    document.documentElement.style.setProperty("--down-arrow", `url('data:image/svg+xml,${encodedDownSVG}')`);
//                    document.documentElement.style.setProperty("--up-arrow", `url('data:image/svg+xml,${encodedUpSVG}')`);
//                    document.documentElement.style.setProperty("--close-icon", `url('data:image/svg+xml,${encodedXSVG}')`);
//                    document.documentElement.style.setProperty("--vector-run-icon", `url('data:image/svg+xml,${encodedvectorRunIcon}')`);
//                    document.documentElement.style.setProperty("--login-icon", `url('data:image/svg+xml,${encodedloginIcon}')`);
//                    document.documentElement.style.setProperty("--bg-image", `url('${payload.Logo}')`);
//                    document.documentElement.style.setProperty("--mbg-image", `url("${sanitizedSplash}")`);
//                    let diableColor = getDisabledColor(payload.BackGround)
//                    document.documentElement.style.setProperty("--disabled-background", diableColor);
//                    let mutedColor = getMutedColor(payload.BackGround)
//                    document.documentElement.style.setProperty("--muted-background", mutedColor);
//                    const bgElement = document.querySelector('.main-bg');
//                    if (bgElement) {
//                        bgElement.style.backgroundImage = `url("${sanitizedSplash}")`;
//                    }
//                    const lgElement = document.querySelector('.menulogo');
//                    if (lgElement) {
//                        lgElement.style.backgroundImage = `url("${sanitizedLogo}")`;
//                    }
                    ////
                    showToast("success", 'Branding saved successfully.');
                }

                return response.data;
            })
            .catch((reason) => {
                setIsSaving(false);
                if (reason) {
                    showToast("error", reason);
                }
                else if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
                return null;
            });
       
    }



    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
    }), []);
    const handleDelete = async (params) => {
        try {
            setPopUp(false);
            setNotifyMails(params);
            setDeleteConfirmPopUp(true);
        } catch (error) {
            toast.error("Error deleting user:", error);
        }
    };

    const handleUpdate = async (params) => {
        const updatedData = params.node.data;
        const newRecord = {
            email: updatedData.email,
            domainName: updatedData.domainName,
            tenantNotificationID: updatedData.tenantNotificationID,
            failure: updatedData.failure,
            success: updatedData.success,
            warning: updatedData.warning,
            restore: updatedData.restore,
            // Task 9 (D3) — every one of these payloads lists the flags explicitly, so a new column
            // is silently dropped unless it is added to all of them.
            suppressionexpiry: updatedData.suppressionexpiry,
        };
        updatedData.changed = !updateUser(newRecord);
        params.node.setData(updatedData);
    }

    const handleCancel = (params) => {
        const updatedData = params.node.data;
        updatedData.failure = updatedData.tempfailure;
        updatedData.success = updatedData.tempsuccess;
        updatedData.warning = updatedData.tempwarning;
        updatedData.restore = updatedData.temprestore;
        updatedData.suppressionexpiry = updatedData.tempsuppressionexpiry;
        updatedData.changed = false;
        params.node.setData(updatedData);
        
    }


    const handleAddMail = (event) => {
        const newEmail = event.target.parentElement.parentElement.querySelector('input[type="addemail"]').value;
        const newRecord = {
            email: newEmail,
            domainName: tenantDomain,
            tenantNotificationID: 1,
            failure: false,
            success: false,
            warning: false,
            restore: false,
            // Task 9 (N6) — a NEW recipient is subscribed to expiry warnings by default, matching the
            // decision that existing recipients are too.
            suppressionexpiry: true
        };
        addUser(newRecord);
    };

    const frameworkComponents = {
        checkboxRenderer: (props) => {
            const handleFeatureCheckboxChange = () => {
                const updatedData = [...rowData];
                const row = updatedData[props.node.rowIndex];
                if (row) {
                    row[props.colDef.field] = !props.value;
                    setRowData(updatedData);
                }
            };

            return (
                <input
                    type="checkbox"
                    checked={props.value}
                    onChange={handleFeatureCheckboxChange}
                />
            );
        }
    };


    const [validation, setValidation] = useState({
        isAdminEmailValid: true,
        adminEmailErrorMessage: "",
        isNotificationEmailValid: true,
        notificationEmailErrorMessage: "",
        isEncryptionValid: true,
        encryptionErrorMessage: "",
        isEncryptionKeyValid: true,
        encryptionKeyErrorMessage: "",
    });

    const closeModal = (e) => {
        setPopUp(false)
    };
    async function assingBranding() {
        const brandingValue = await getItem("Branding");
        var actualBranding = JSON.parse(brandingValue);
        setBrandings((prevState) => ({
            ...prevState,
            BackGround: actualBranding.BackGround ,
            PrimaryText: actualBranding.PrimaryText ,
            SecondaryText: actualBranding.SecondaryText,
            SecondaryIcon: actualBranding.SecondaryIcon ,
            ButtonBack: actualBranding.ButtonBack ,
            ButtonText: actualBranding.ButtonText ,
            HeaderBack: actualBranding.HeaderBack ,
            HeaderText: actualBranding.HeaderText,
            Domain: actualBranding.Domain,
            Logo: actualBranding.Logo,
            Splash: actualBranding.Splash
        }));
    }
    useEffect(() => {
        assingBranding()
        getAllSettings();
        getSettings();
        defaultBrandingList();
        async function getSettings() {
            try {
                const resellerOrganisation = await getItem("ResellerOrganisation");
                const reseller = await getItem("ResellerOrgs");
                var resellerOrgs = JSON.parse(reseller);
                var orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
                if (resellerOrgs){
                    const matchedOrg = resellerOrgs.find(org => org.orgId === orgId);
                    if (matchedOrg && matchedOrg.isReseller) {
                        setIsReseller(true)
                    }
                }
                else{
                    resellerOrgs = JSON.parse(resellerOrganisation);
                    const matchedOrg = resellerOrgs.find(org => org.orgId === orgId);
                    if (matchedOrg && matchedOrg.isReseller) {
                        setIsReseller(true)
                    }
                }
                
            }
            catch (error) {
            console.log(error)
            }
        }
        async function getAllSettings() {

            try {

                var tokenString = await setAuthContext("", new Date());

                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };

                const orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
                await Axios.get(API_ROUTE + Routes.GET_ALL_SETTINGS + '/' + orgId, config)
                    .then((response) => {
                        
                        if (response && response.data) {

                            setManaged(response.data.managed);
                            ////setEndUserRecovery(response.data.endUserRecovery);
                            setAdminEmailAddress(response.data.adminEmailAddress);
                            setNotificationEmailAddress(response.data.notificationEmailAddress);
                            ////setNotificationType(trim(response.data.notificationType));
                            ////setGoCardlessID(response.data.goCardlessID);
                            setResellerID(response.data.resellerID);
                            ////setTennantNameD(response.data.tennantName);
                            setRestoreEmailType(response.data.restoreMailTo);
                            setEncryption(response.data.encryption);
                            if (response.data.encryptionKey && response.data.encryptionKey !=="")
                            {
                                setEncryptionKey("true");
                            }

                        }

                    })
                    .catch((reason) => {
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";                        }
                    });

            }
            catch (error) { }
            setIsLoading(false);
        }
    },[]);
    const showToast = (type, message) => {
        if (type === "success") {
            toast.success(message, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        }
        else if (type === "error") {
            toast.error(message, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        } else if (type === "warning") {
            toast.warning(message, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        }
    };
    useEffect(() => {
        ////fetchGroups();
        FetchTawkChat();
        // Task 9 (D3/N6) — its own read; see loadSuppressionExpiryWarnings.
        loadSuppressionExpiryWarnings();
        NotificationEmailList();
    },[]);
    ////async function fetchGroups() {
    ////    try {

    ////        var tokenString = await setAuthContext("", new Date());

    ////        const config = {
    ////            headers: {
    ////                Authorisation: `Bearer ${tokenString}`,
    ////                'Content-Type': 'application/json',
    ////                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
    ////            },
    ////        };
    ////        const response = await Axios.get(API_ROUTE + Routes.GET_AllAZURE_GROUP, config);
    ////        ////setGroups(response.data);  
    ////        ////updateCheckboxes(response.data);
    ////    } catch (error) {
    ////        console.error('Error fetching groups:', error);
    ////        if (error?.response?.status === 440) {
    ////            window.location.href = "/TimeoutErrorHandler";            }
    ////    }
    ////}


    ////function updateCheckboxes(groups) { 
    ////    const updatedCheckboxes = {
    ////        VeeamAdmin: groups.some((group) => group.displayName === 'CloudCover365Admin'),
    ////        Setting: groups.some((group) => group.displayName === 'CloudCover365Engineer'),
    ////        MainPage: groups.some((group) => group.displayName === 'CloudCover365JobManagement'),
    ////        RestorePage: groups.some((group) => group.displayName === 'CloudCover365Restore'),
    ////        EndUserRestore: groups.some((group) => group.displayName === 'CloudCover365EndUserRecovery'),
    ////    };

    ////    ////const updatedDisabledCheckboxes = {
    ////    ////    VeeamAdmin: updatedCheckboxes.VeeamAdmin,
    ////    ////    Setting: updatedCheckboxes.Setting,
    ////    ////    MainPage: updatedCheckboxes.MainPage,
    ////    ////    RestorePage: updatedCheckboxes.RestorePage,
    ////    ////    EndUserRestore: updatedCheckboxes.EndUserRestore,
    ////    ////};

    ////    ////setCheckboxes(updatedCheckboxes);
    ////    ////setDisabledCheckboxes(updatedDisabledCheckboxes);
    ////}



    async function setSettings(settingsName,settingsValue) {

        try {
            var tokenString = await setAuthContext("", new Date());

            let apiRoute;
            switch (settingsName) {
                case "Managed":
                    apiRoute = Routes.SET_MANAGED;
                    break;

                case "NotificationEmail":
                    apiRoute = Routes.SET_NOTIFICATION_EMAIL;
                    break;

                case "RestoreMailTo":
                    apiRoute = Routes.SET_RESTORE_MAIL_TO
                    break;
                case "AdminEmail":
                    apiRoute = Routes.SET_ADMIN_EMAIL;
                    break;
                default:
                    apiRoute = "";
                    break;
            }
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            await Axios.patch(API_ROUTE + apiRoute + '/' +orgId + '/' + settingsValue, "", config)
                .then((response) => {

                    if (response && response.data && response.data.length > 0) {


                    }

                })
                .catch((reason) => {
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";                    }
                });

        }
        catch (error) { }

    }
    async function TawkChat(newValue) {
        try {
            var tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const inputData = {
                OrgId: urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId"),
                Setting: "TawkChat",
                SettingValue: newValue.toString(),

            };
            const orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            await Axios.patch(API_ROUTE + Routes.SET_TAWK + '/' + orgId + '/' + newValue.toString(), "", config)
            .then((response) => {
            })

        }
        catch (reason) { 
            if (reason?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }

    }

    async function NewStyleNotifications(newValue) {
        try {
            var tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            await Axios.patch(API_ROUTE + Routes.SET_NEW_STYLE_NOTIFICATIONS + '/' + orgId + '/' + newValue.toString(), "", config)
            .then((response) => {
            })

        }
        catch (reason) {
            if (reason?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }

    }

    /**
     * Task 9 (D3/N6) — the organisation switch for the suppression-expiry digest.
     *
     * Read and write both go straight to CoreAPIBackEnd over HTTP. The newStyleNotifications toggle
     * above reads its state from the WCF-backed OrgSettings call; this one deliberately does not, so
     * the feature needed no change to a generated service contract.
     */
    async function SuppressionExpiryWarnings(newValue) {
        try {
            const tokenString = await setAuthContext("", new Date());
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            await Axios.patch(API_ROUTE + Routes.SET_SUPPRESSION_EXPIRY_WARNINGS(orgId, newValue), "", config);
        }
        catch (reason) {
            if (reason?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
            else {
                // Put the switch back: leaving it showing a state the server rejected is worse than
                // an error, because the customer would believe they had opted out.
                setSuppressionExpirySlide(!newValue);
                toast.error("Could not update the suppression expiry warning setting.");
            }
        }
    }

    async function loadSuppressionExpiryWarnings() {
        try {
            const tokenString = await setAuthContext("", new Date());
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            const response = await Axios.get(API_ROUTE + Routes.GET_SUPPRESSION_EXPIRY_WARNINGS(orgId), config);
            // The endpoint returns a bare boolean; anything unexpected leaves the default (on) alone
            // rather than showing a customer as opted out on a bad read.
            if (typeof response?.data === "boolean") setSuppressionExpirySlide(response.data);
        }
        catch {
            // Non-fatal: the switch keeps its default. A failed read must not block the settings page.
        }
    }

    async function FetchTawkChat() {

        try {
            var tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const inputData = {
                OrgId: urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId"),
                Setting: "TawkChat",

            };
            const orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            await Axios.get(API_ROUTE + Routes.GET_ORG_SETTINGS + '/' + orgId, config)
                .then((response) => {
                    const result = response.data?.tawkChat === "True";
                    setTawkChatSlide(result);
                    setNewStyleNotificationsSlide(response.data?.newStyleNotifications === "True");
                })
        }
        catch (reason) { 
            if (reason?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }
    }
    async function setEncryptionKeySettings(settingsValue) {

        try {

            var tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            const inputData = {
                OrgId: orgId,
                EncryptionKey: settingsValue
            };
            await Axios.post(API_ROUTE + Routes.ENCRYPT_AND_SAVE(orgId), inputData, config)
                .then((response) => {

                    if (response && response.data && response.data) {

                       // toast(response.data);

                        if (response.data.toString() === "Success") {
                            toast.success("Encryption key has been created successfully");
                            setEncryptionKey("true");
                        }
                        else {
                            toast.error("An error occurred while updating the encryption key. Please contact support for assistance.");
                        }
                    }
                    else {
                        toast.error("An error occurred while updating the encryption key. Please contact support for assistance.");
                    }
                })
                .catch((reason) => {
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";                    }
                });

        }
        catch (error) { }

    }

    //function checkRowDataChange(params) {
    //    const { data } = params;
    //    const orgData = notifyMails?.[params.node?.rowIndex];

    //    if (!orgData || !data) {
    //        return false; // Invalid or missing data
    //    }

    //    // Dynamically compare fields
    //    const keys = ['failure', 'warning', 'success', 'restore'];
    //    return keys.every((key) => data[key] === orgData[key]);
    //}

    const handleCheckboxMailChange = (field, params) => (e) => {
        const updatedData = { ...params.node.data };
        updatedData[field] = e.target.checked;
        updatedData.changed =
        e.target.checked.toString() !== updatedData[`temp${field}`]?.toString();
        params.node.setData(updatedData);
    };

    async function NotificationEmailList() {
        try {
            const tokenString = await setAuthContext("", new Date());
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const response = await Axios.get(API_ROUTE + Routes.GET_ALL_NOTIFICATION_SETTINGS + `/` + tenantDomain, config);
            if (response && response.data) {
                const responseData = JSON.parse(JSON.stringify(response.data));
                // Use a Set to track unique emails
                const Emails = new Set();
                const filteredData = responseData.filter(item => {
                    const email = item.email.trim().toLowerCase();
                    if (Emails.has(email)) {
                        return false;
                    }
                    Emails.add(email);
                    return true;
                });

                const data = filteredData.map(item => ({
                    ...item,
                    tempfailure: item.failure,
                    tempwarning: item.warning,
                    tempsuccess: item.success,
                    temprestore: item.restore,
                    tempsuppressionexpiry: item.suppressionexpiry,
                    changed: false
                }));
                setRowData(data)
                setAddNotificationEmail("");
            }

        } catch (error) {
            console.error("Error occurred while fetching notification emails:", error);
        }
    }
    
    async function PopUpForNotificationEmail() {
        try {
            const tokenString = await setAuthContext("", new Date());
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const response = await Axios.get(API_ROUTE + Routes.GET_ALL_NOTIFICATION_SETTINGS + `/` + tenantDomain , config);
            if (response && response.data) {
                const responseData = JSON.parse(JSON.stringify(response.data));
                const Emails = new Set();
                const filteredData = responseData.filter(item => {
                    const email = item.email.trim().toLowerCase();

                    if (Emails.has(email)) {
                        return false;
                    }
                    Emails.add(email);
                    return true;
                });
                const data = filteredData.map(item => ({
                    ...item, 
                    tempfailure: item.failure,  
                    tempwarning: item.warning,  
                    tempsuccess: item.success,  
                    temprestore: item.restore,
                    tempsuppressionexpiry: item.suppressionexpiry,
                    changed: false
                }));
                setRowData(data)
                setAddNotificationEmail("");
                setEmailValidation({isNotificationEmailValid: true, notificationEmailErrorMessage: "", disabled: true, });
            }

            setColumnDefs(
                [
                    {
                        headerName: "Email ID",
                        field: "email", flex: 1,
                        minWidth: 200,
                        editable: (params) => params.data.tenantNotificationID === 0, 
                    },
                    {
                        headerName: "Failure",
                        field: "failure",
                        headerStyle: { textAlign: "center", fontWeight: "bold" },
                        headerComponentParams: {
                            style: { display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" },
                        },
                        //cellStyle: { textAlign: "center" },
                        cellRenderer: (params) => (
                            <input
                                type="checkbox"
                                checked={params.value || false}
                                onChange={handleCheckboxMailChange("failure".toLowerCase(), params)}
                                style={{
                                    cursor: "pointer",
                                    accentColor: "rgb(81, 145, 206)",
                                }}
                            />
                        ),
                        flex: 1,
                        minWidth: 100
                    },
                    {
                        headerName: "Success",
                        field: "success",
                        headerStyle: { textAlign: "center", fontWeight: "bold" },
                        headerComponentParams: {
                            style: { display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" },
                        },
                        //cellStyle: { textAlign: "center" },
                        cellRenderer: (params) => (
                            <input
                                type="checkbox"
                                checked={params.value || false}
                                onChange={handleCheckboxMailChange("success".toLowerCase(), params)}
                                style={{
                                    cursor: "pointer",
                                    accentColor: "rgb(81, 145, 206)",
                                }}
                            />
                        ),
                        flex: 1,
                        minWidth: 100
                    },
                    {
                        headerName: "Warning",
                        field: "warning",
                        headerStyle: { textAlign: "center", fontWeight: "bold" },
                        headerComponentParams: {
                            style: { display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" },
                        }, flex: 1,
                        //cellStyle: { textAlign: "center" },
                        cellRenderer: (params) => (
                            <input
                                type="checkbox"
                                checked={params.value || false}
                                onChange={handleCheckboxMailChange("warning".toLowerCase(), params)}
                                style={{
                                    cursor: "pointer",
                                    accentColor: "rgb(81, 145, 206)",
                                }}
                            />
                        ),
                        minWidth: 100
                    },
                    {
                        headerName: "Restore",
                        field: "restore",
                        headerStyle: { textAlign: "center", fontWeight: "bold" },
                        headerComponentParams: {
                            style: { display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" },
                        },
                        //cellStyle: { textAlign: "center" },
                        cellRenderer: (params) => (
                            <input
                                type="checkbox"
                                checked={params.value || false}
                                onChange={handleCheckboxMailChange("restore".toLowerCase(), params)}
                                style={{
                                    cursor: "pointer",
                                    accentColor: "rgb(81, 145, 206)",
                                }}
                            />
                        ), flex: 1,
                        minWidth: 100
                    },
                    // Task 9 (D3/N6) — suppression-expiry digest opt-in. Unlike the four columns
                    // above, an UNSET value renders ticked: this column is nullable and NULL means
                    // subscribed, so every recipient predating the feature shows as opted in.
                    {
                        headerName: "Expiry",
                        field: "suppressionexpiry",
                        headerStyle: { textAlign: "center", fontWeight: "bold" },
                        headerComponentParams: {
                            style: { display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" },
                        },
                        //cellStyle: { textAlign: "center" },
                        cellRenderer: (params) => (
                            <input
                                type="checkbox"
                                checked={params.value === undefined || params.value === null ? true : params.value}
                                onChange={handleCheckboxMailChange("suppressionexpiry".toLowerCase(), params)}
                                style={{
                                    cursor: "pointer",
                                    accentColor: "rgb(81, 145, 206)",
                                }}
                            />
                        ), flex: 1,
                        minWidth: 100
                    },
                    {
                        headerName: "Options",
                        field: "actions",
                        headerStyle: { textAlign: "center", fontWeight: "bold" },
                        headerComponentParams: {
                            style: { display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" },
                        }, flex: 1,
                        minWidth: 100,
                        //cellStyle: { textAlign: "center" },
                        cellRenderer: (params) =>
                        {

                            return !params.data.changed && (params.data.tenantNotificationID !== 0) ?
                                (<div>
                                    <button
                                        onClick={() => handleDelete(params.data)}
                                        className="btn btn-danger btn-sm"
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "red"
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                        </svg>
                                    </button>
                                    </div>):
                                (<div >
                                            <button
                                                onClick={() => handleUpdate(params)}
                                                className="btn btn-danger btn-sm"
                                                style={{
                                                    background: "transparent",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    color: "red"
                                                }}
                                            >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-floppy" viewBox="0 0 16 16">
                                                    <path d="M11 2H9v3h2z" />
                                                    <path d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z" />
                                                </svg>
                                            </button>
                                            <button
                                                onClick={() => handleCancel(params)}
                                                className="btn btn-danger btn-sm"
                                                style={{
                                                    background: "transparent",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    color: "red"
                                                }}
                                            >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"  className="bi bi-x-lg" viewBox="0 0 16 16">
                                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                                </svg>
                                            </button>
                                        </div>)                                    
                        }
                    }
                ]
            );
            setPopUp(true);
        } catch (error) {
            console.error("Error occurred while fetching notification emails:", error);
            if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";            }
        }
    }


    async function addUser(payload){
        try {
            setIsSubmitting(true);
            const tokenString = await setAuthContext("", new Date());

            //const DomainName = localStorage.getItem("ManageOrgName") ? localStorage.getItem("ManageOrgName") : "";

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const isDuplicate = rowData.some(
                item => item.email.trim().toLowerCase() === payload.email.trim().toLowerCase()
            );

            if (isDuplicate) {
                setEmailValidation({
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Email address already exists",
                    disabled: true,
                });
                return;
            }
            const data = {
                email: payload.email,
                domainName: payload.domainName,
                tenantNotificationID: 0,
                failure: payload.failure,
                success: payload.success,
                warning: payload.warning,
                restore: payload.restore,
                suppressionexpiry: payload.suppressionexpiry
            }

            const response = await Axios.post(API_ROUTE + Routes.ADD_NOTIFICATION_MAIL, data, config);

            if (response && response.data) {
                PopUpForNotificationEmail()
                toast.success("Notification Mail Added successfully", response.data);
            }

        } catch (error) {
            toast.error("Error occurred while fetching notification emails");
            if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }
        finally {
            setIsSubmitting(false);
        }
    }

    async function deleteUser(){
        try {
            const tenantNotificationID = notifyMails.tenantNotificationID;
            const tokenString = await setAuthContext("", new Date());
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };

            const response = await Axios.delete(API_ROUTE + Routes.DELETE_NOTIFICATION_MAIL + `/` + tenantNotificationID, config);
            if (response && response.data) {
                toast.success("Deleted successfully");
            }
            setDeleteConfirmPopUp(false);
            PopUpForNotificationEmail();
        } catch (error) {
            toast.error("Error occurred while fetching notification emails");
            if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";            }
        }
    }

    async function updateUser(payload) {
        try {

            const tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const data = {
                email: payload.email,
                domainName: payload.domainName,
                tenantNotificationID: payload.tenantNotificationID,
                failure: payload.failure,
                success: payload.success,
                warning: payload.warning,
                restore: payload.restore,
                suppressionexpiry: payload.suppressionexpiry
            }

            const response = await Axios.put(API_ROUTE + Routes.UPDATE_NOTIFICATION_MAIL, data, config);

            if (response && response.data) {
                toast.success("Notification Mail settings updated successfully");
                PopUpForNotificationEmail();
                return response.data
            }
        } catch (error) {
            console.error("Error occurred while fetching notification emails:", error);
            if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";            }
        }
    }
    async function setEncryptionSettings(settingsValue) {

        try {

            var tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const inputData = {
                OrgId: urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId"),
              
                PostString: settingsValue,
                TenantName: sessionStorage.getItem("ManageOrgName") ? sessionStorage.getItem("ManageOrgName") : "",
                EmailAddress: sessionStorage.getItem("UserName") ? sessionStorage.getItem("UserName") : "",
               // Url: "/v8/Organizations/" + (urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId")),


            };
            const orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            await Axios.patch(API_ROUTE + Routes.SET_ENCRYPTION + '/' + orgId, inputData, config)
                .then((response) => {

                    if (response && response.data && response.data) {

                       // toast(response.data);

                        if (response.data.toString() === "Your key has been added to the store") {
                            toast.success("Encryption key has been created successfully")
                            setEncryption("true")
                        }
                        else {
                            toast.error("An error occurred while updating the encryption key. Please contact support for assistance.");
                        }
                    }
                    else {
                        toast.error("An error occurred while updating the encryption key. Please contact support for assistance.");
                    }
                })
                .catch((reason) => {
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";                    }

                });

        }
        catch (error) { }

    }

    const handleChkBoxDelegatedMgt = (event) => {
        setManaged(event.target.checked.toString()); // Update the state with the new checkbox value
        setSettings('Managed', event.target.checked.toString());
        if (event.target.checked) {
            toast.success("Enabled Delegated management for organisation", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        }
        else {
            toast.success(" Disabled Delegated management for organisation", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        }

    };


    const setUpClick = (event) => {
        window.parent.location.href = '/SignUp';
    };
    const orgID = urlParams.get("orgId");
    const reseller = sessionStorage.getItem("ResellerID");
    const sessionOrgID = sessionStorage.getItem('orgId');
    ////console.log(orgID, sessionOrgID, reseller ,"test")
    const NotificationEmailUpdate = (event) => {

        if (validation.isNotificationEmailValid) {
            const updatedEmail = event.target.parentElement.parentElement.querySelector('input[type="email"]').value;

            setNotificationEmailAddress(updatedEmail); // Update the state with the new email address
            setSettings('NotificationEmail', updatedEmail); // Optiona
        }
        else {

            showToast("error", validation.notificationEmailErrorMessage);
        }
    };



    const handleRestoreEmailTypeClick = (restoreMailTo) => {
        setRestoreEmailType(restoreMailTo); // Update the state with the new checkbox value
        setSettings('RestoreMailTo', restoreMailTo);
    };

    const adminEmailChange = (event) => {
        const updatedEmail = event.target.parentElement.parentElement.querySelector('input[type="email"]').value;

        setAdminEmailAddress(updatedEmail); // Update the state with the new email address
        const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+(?:\.[a-zA-Z0-9._%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/;

        if (updatedEmail !== "" && updatedEmail.length < 510 && emailPattern.test(updatedEmail)) {
            setValidation({
                ...validation,
                isAdminEmailValid: true,
                adminEmailErrorMessage: ""
            });
        }
        else {
            if (updatedEmail === "") {
                setValidation({
                    ...validation,
                    isAdminEmailValid: false,
                    adminEmailErrorMessage: "Email should not be Empty"
                });
                //  showToast("error", "Email should not be Empty");
            }
            else if (!emailPattern.test(updatedEmail)) {
                setValidation({
                    ...validation,
                    isAdminEmailValid: false,
                    adminEmailErrorMessage: "Enter a valid email address"

                });
                // showToast("error", "Enter a valid email address");
            }
            else {
                setValidation({
                    ...validation,
                    isAdminEmailValid: false,
                    adminEmailErrorMessage: "Email Should not be more than 510 character "
                });
                // showToast("error", "Email Should not be more than 510 character");
            }
        }
    };

    const notificationEmailChange = (event) => {
        const updatedEmail = event.target.parentElement.parentElement.querySelector('input[type="email"]').value;

        setNotificationEmailAddress(updatedEmail); // Update the state with the new email address
        const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+(?:\.[a-zA-Z0-9._%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/;

        if (updatedEmail !== "" && updatedEmail.length < 510 && emailPattern.test(updatedEmail)) {
            setValidation({
                ...validation,
                isNotificationEmailValid: true,
                notificationEmailErrorMessage: ""
            });
        }
        else {
            if (updatedEmail === "") {
                setValidation({
                    ...validation,
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Email should not be Empty"
                });
                // showToast("error", "Email should not be Empty");

            }
            else if (!emailPattern.test(updatedEmail)) {
                setValidation({
                    ...validation,
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Enter a valid email address"
                });
                //  showToast("error", "Enter a valid email address");
            }
            else {
                setValidation({
                    ...validation,
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Email Should not be more than 510 character "
                });
                // showToast("error", "Email Should not be more than 510 character");
            }
        }
    };

    const addNotificationEmailChange = (event) => {
        const updatedEmail = event.target.parentElement.parentElement.querySelector('input[type="addemail"]').value;

        //addNotificationEmail

        setAddNotificationEmail(updatedEmail);
        const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+(?:\.[a-zA-Z0-9._%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/;

        if (updatedEmail !== "" && updatedEmail.length < 510 && emailPattern.test(updatedEmail) && !rowData.some(item => item.email === updatedEmail) && rowData.length < 5) {
            setEmailValidation({
                isNotificationEmailValid: true,
                notificationEmailErrorMessage: "",
                disabled: false,
            });
        }
        else {
            if (updatedEmail === "") {
                setEmailValidation({
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Email should not be Empty",
                    disabled: true,
                });
            }
            else if (rowData.length >= 5) {
                setEmailValidation({
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Only 5 email addresses can be added.",
                    disabled: true,
                });
            }
            else if (rowData.some(item => item.email === updatedEmail))
            {
                setEmailValidation({
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Email address already exist",
                    disabled: true,
                });
            }
            else if (!emailPattern.test(updatedEmail)) {
                setEmailValidation({
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Enter a valid email address",
                    disabled: true,
                });
            }
            else {
                setEmailValidation({
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Email Should not be more than 510 character ",
                    disabled: true,
                });
            }
        }
    };
    const adminEmailUpdate = (event) => {

        if (validation.isAdminEmailValid) {
            const updatedEmail = event.target.parentElement.parentElement.querySelector('input[type="email"]').value;

            setAdminEmailAddress(updatedEmail); // Update the state with the new email address
            setSettings('AdminEmail', updatedEmail); // Optiona
        }
        else {
            showToast("error", validation.adminEmailErrorMessage)
        }
    };

    const encryptionUpdate = (event) => {

        const updatedEncryption = event.target.parentElement.parentElement.querySelector('input[type="password"]').value;

        if (updatedEncryption !== "" && validation.isEncryptionValid === true) {
            setEncryptionSettings(updatedEncryption);
        }
        else {
            showToast("error", "Please enter the encryption key")
        }

    };
    const encryptionKeyUpdate = (event) => {

        const updatedEncryption = event.target.parentElement.parentElement.querySelector('input[type="password"]').value;

        if (updatedEncryption !== "" && validation.isEncryptionKeyValid === true) {
            setEncryptionKeySettings(updatedEncryption);
        }
        else {
            showToast("error", "Please enter the encryption key")
        }

    };
    return (
        <Container width='100%' id="setting_container">
            <NavBar page="settings" authContext={authContext} />
            <div>
                <Col sm={12}>
                    <Col md={12}>
                        <Card id="TenantSettings" style={{ margin:'0 11px' }}>
                            <Card.Header
                                className="setting_header SectionTitle"
                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            >
                                <div>TENANT SETTINGS</div>
                                <div style={{ fontWeight: 'bold' }}>
                                    {tenantDomain}
                                </div>
                            </Card.Header>
                        </Card>
                    </Col>
                </Col>
            </div>
            <div className="ps-2 pe-2 pb-3 pt-3" style={{ maxHeight: '87vh', overflowY: 'auto', overflowX: 'hidden' }} >
                {isLoading ? (
                    <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '85vh' }}>
                        <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                    </div>
                ) : (

                    <Row>
                        {/* Delegated Management */}
                        <Col sm={12} md={6}  >
                            <Col md={12} className="mb-3">
                                <Card style={{}} id="DelegatedManagement">
                                        <Card.Header className="setting_header SectionTitle"
                                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}   >DELEGATED MANAGEMENT</Card.Header>
                                    <Card.Body>
                                        <Card.Text>
                                            <Form.Label>If you enable this feature, administrators from your vendor's organisation will be able to perform the following tasks:</Form.Label>
                                        </Card.Text>
                                        <ul>
                                            <li>Create and administer backup jobs.</li>
                                            <li>Create and administer backup repositories.</li>
                                            <li>Perform restore tasks on behalf of your users.</li>
                                        </ul>

                                    <Form.Check type="checkbox" id="ChkBoxDelegatedMgt" label="Allow delegated management for my organisation" name="DelegatedManagement" checked={managed === 'true'} onChange={handleChkBoxDelegatedMgt}/>

                            </Card.Body>
                        </Card></Col>
                        <Col md={12} className="mb-3"> <Card style={{}}>
                                    <Card.Header className="setting_header SectionTitle">UPDATE SETTINGS</Card.Header>
                            <Card.Body>
                                <Card.Text>
                                    This section should be used if requested by our support team, simply click the buttons below as directed.
                                    The process will update your configuration. No data or jobs will be altered.
                                </Card.Text>
                                <Form >
                                    <Form.Group controlId="formNotificationEmail" className="d-flex">
                                        <Button variant="primary" onClick={setUpClick} >Update Link</Button>
                                    </Form.Group>
                                </Form>

                                </Card.Body>
                            </Card></Col>
                            {resellerID && resellerID === "1" &&
                                <Col md={12} className="mb-3"> <Card style={{}}>
                                        <Card.Header className="setting_header SectionTitle">BILLING ADMINISTRATION</Card.Header>
                                    <Card.Body>
                                        <Card.Text>
                                            If you are paying by Direct Debit, you will receive invoices from this system, these will be sent to the address below:
                                        </Card.Text>
                                        <Form>
                                            <Form.Label>Email address</Form.Label>
                                            <Form.Group controlId="formBillingEmail">

                                            <InputGroup className="mb-3">
                                                <Form.Control type="email" placeholder="Enter email" isInvalid={!validation.isAdminEmailValid} onChange={adminEmailChange} value={adminEmailAddress} />
                                                <Button variant="primary" onClick={adminEmailUpdate}>Update</Button>
                                            </InputGroup>
                                            <Form.Control.Feedback type="invalid">
                                                {validation.adminEmailErrorMessage}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        </Form>


                                </Card.Body>
                            </Card></Col>}
                        <Col md={12} className="mb-3"><Card style={{}} id="RestoreOptions">
                                    <Card.Header className="setting_header SectionTitle">RESTORE EMAIL OPTIONS</Card.Header>
                            <Card.Body>
                                <Card.Text>
                                   For security reasons you may wish to restrict where restore files can be mailed to.
                                </Card.Text>
                                
                                <Form>
                                  <Form.Label>Please select an email restore option:</Form.Label>
                                    <Form.Group controlId="formRestoreemailOption" className="d-flex">
                                        <Form.Check type="radio" id="emailOptionNoEmail" label="No Email" name="EmailOption" checked={restoreEmailType === "0"} onChange={() => handleRestoreEmailTypeClick("0")} />
                                        <Form.Check type="radio" id="emailOptionOrgOnly" label="Email to Organisation only" name="EmailOption" checked={restoreEmailType === "1"} onChange={() => handleRestoreEmailTypeClick("1")} /> 
                                        <Form.Check type="radio" id="emailOptionAnywhere" label="Email anywhere" name="EmailOption" checked={restoreEmailType === "2"} onChange={() => handleRestoreEmailTypeClick("2")} />
                                      
                                    </Form.Group>
                                </Form>
                            </Card.Body>
                                </Card></Col>
                                <Col md={12} className="mb-3"><Card style={{}}>
                                    <Card.Header className="setting_header SectionTitle">GUARDIAN AZURE STORAGE ENCRYPTION</Card.Header>
                                    <Card.Body>
                                        <Card.Text>
                                            Guardian Azure allows you to configure a password that you can use to encrypt data in object storage repositories using the AES-256 specification.
                                        </Card.Text>
                                        <Form>
                                            <Form.Group controlId="formStorageEncryptionKey">
                                                <Form.Label>Guardian Azure Encryption Key</Form.Label>
                                                {encryptionKey === "true" ? (<Form.Control type="password" value="" disabled placeholder="Already Enabled" />
                                                )
                                                    : (<InputGroup className="mb-3">
                                                        <Form.Control type="password" isInvalid={!validation.isEncryptionKeyValid} onChange={(event) => {
                                                            const updatedEncryption = event.target.parentElement.parentElement.querySelector('input[type="password"]').value;


                                                            if (updatedEncryption === "") {
                                                                setValidation({
                                                                    ...validation,
                                                                    isEncryptionKeyValid: false,
                                                                    encryptionKeyErrorMessage: "Encryption Key should not be Empty"
                                                                });

                                                            }
                                                            else {
                                                                setValidation({
                                                                    ...validation,
                                                                    isEncryptionKeyValid: true,
                                                                    encryptionKeyErrorMessage: ""
                                                                });
                                                            }

                                                        }} placeholder="Enter Encryption Key" />
                                                        <Button variant="primary" value="" onClick={encryptionKeyUpdate}>Update</Button>
                                                    </InputGroup>)
                                                }
                                                <Form.Control.Feedback type="invalid">
                                                    {validation.encryptionKeyErrorMessage}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                        </Form>
                                    </Card.Body>
                                </Card></Col>
                                {(orgID === sessionOrgID && reseller >1) &&
                                    <Col md={12} className="mb-3 mt-3"><Card id = "RealTawkChat">
                                        <Card.Header className="setting_header SectionTitle">REAL TIME CHAT</Card.Header>
                                        <Card.Body>
                                            <Card.Text>
                                                Interative chat allow us to support your clients in real time. If you would like to disable this feature, you can do so here.
                                            </Card.Text>
                                            <Form style={{ alignItems: "center", display: "flex", justifyContent: "center", flexDirection:"column"}}>
                                                <Form.Group controlId="formTawkChats">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <div
                                                            onClick={handleSlideChange}
                                                            style={{
                                                                width: '50px',
                                                                height: '24px',
                                                                borderRadius: '9999px',
                                                                backgroundColor: tawkChatSlide ? '#0f5730' : '#ccc',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                position: 'relative',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.3s ease'
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    left: tawkChatSlide ? '26px' : '2px',
                                                                    top: '2px',
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    borderRadius: '50%',
                                                                    backgroundColor: '#fff',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    transition: 'left 0.3s ease'
                                                                }}
                                                            >
                                                                {tawkChatSlide && (
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="12"
                                                                        height="12"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="#0f5730"
                                                                        strokeWidth="3"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    >
                                                                        <polyline points="20 6 9 17 4 12" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <span
                                                            style={{
                                                                marginLeft: '8px',
                                                                fontSize: '12px',
                                                                fontWeight: 'bold',
                                                                color: tawkChatSlide ? '#0f5730' : '#999'
                                                            }}
                                                        >
                                                            {tawkChatSlide ? 'ON' : 'OFF'}
                                                        </span>
                                                    </div>
                                                </Form.Group>
                                            </Form>
                                        </Card.Body>
                                    </Card></Col>
                                }
                                {(isReseller) && 
                                    <Col md={12} className="mb-3">
                                        <Card style={{}} id="Branding-card">
                                            <Card.Header className="setting_header SectionTitle">Branding</Card.Header>
                                            <Card.Body>
                                                {/*<Card.Text>*/}
                                                {/*    <Form.Label>This functionality has now been replaced with a more granular control for selecting users who can perform restores:</Form.Label>*/}
                                                {/*</Card.Text>*/}
                                                <Row id="branding-form">
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Logo
                                                            <OverlayTrigger placement="right" overlay={<Tooltip style={{ width: '500px' }}>Logo must have an aspect ratio between 4: 1 and 10: 1. </Tooltip>}>
                                                                <InfoCircle className="ms-2" />
                                                            </OverlayTrigger>
                                                        </Form.Label>
                                                        <div>
                                                        
                                                        <Form.Group controlId="formFile">
                                                                <Form.Control type="file" accept=".jpeg, .jpg, .png" className="custom-file-input" ref={bgImageRef} name="Logo" onChange={onFileChange} />
                                                        </Form.Group>
                                                            {brandings.Logo && brandings.Logo !=="" && 
                                                                <div style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    margin: '10px 0px',
                                                                    padding:'0px 10px',
                                                                    marginBottom: 0,
                                                                    width: '100%',
                                                                    height: '200px',
                                                                    borderRadius: '8px',
                                                                    backgroundImage: `
                linear-gradient(45deg, #ccc 25%, transparent 25%),
                linear-gradient(-45deg, #ccc 25%, transparent 25%),
                linear-gradient(45deg, transparent 75%, #ccc 75%),
                linear-gradient(-45deg, transparent 75%, #ccc 75%)
            `,
                                                                    backgroundSize: '40px 40px',
                                                                    backgroundPosition: '0 0, 0 20px, 20px -20px, -20px 0px',
                                                                    overflow: 'hidden',
                                                                    position: 'relative',
                                                                }}>
                                                                    <img src={brandings.Logo} alt="Logo" style={{ width: '100%', borderRadius: '8px', objectFit: 'cover'}} />
                                                        </div>}
                                                        </div>
                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Splash Image
                                                        
                                                            <OverlayTrigger placement="right" overlay={<Tooltip style={{ width: '500px' }}>Splash image must be larger than 1920x1080 and in landscape orientation. </Tooltip>}>
                                                                <InfoCircle className="ms-2" />
                                                            </OverlayTrigger>
                                                            </Form.Label>
                                                        <div>
                                                        <Form.Group controlId="formFile">
                                                                <Form.Control type="file" accept=".jpeg, .jpg, .png" className="custom-file-input" ref={mgImageRef} name="Splash" onChange={onFileChange} />
                                                        </Form.Group>
                                                            {brandings.Splash && brandings.Splash !== "" &&
                                                                <div style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    margin: '10px 0px',
                                                                    padding: '0px 10px',
                                                                    marginBottom: 0,
                                                                    width: '100%',
                                                                    height: '200px',
                                                                    borderRadius: '8px',
                                                                    backgroundImage: `
                linear-gradient(45deg, #ccc 25%, transparent 25%),
                linear-gradient(-45deg, #ccc 25%, transparent 25%),
                linear-gradient(45deg, transparent 75%, #ccc 75%),
                linear-gradient(-45deg, transparent 75%, #ccc 75%)
            `,
                                                                    backgroundSize: '40px 40px',
                                                                    backgroundPosition: '0 0, 0 20px, 20px -20px, -20px 0px',
                                                                    overflow: 'hidden',
                                                                    position: 'relative',
                                                                }}>
                                                                    <img
                                                                        src={brandings.Splash}
                                                                        alt="Background Preview"
                                                                        style={{
                                                                            width: '100%',
                                                                            borderRadius: '8px',
                                                                            maxHeight: '300px', // Optional: prevent overly tall images
                                                                            objectFit: 'cover',  // Make it look more like a background
                                                                        }}
                                                                    />
                                                                </div>}
                                                        </div>

                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Default Theme
                                                            <OverlayTrigger placement="right" overlay={<Tooltip style={{ width: '500px' }}>Preset theme with standard logo and splash image. </Tooltip>}>
                                                                <InfoCircle className="ms-2" />
                                                            </OverlayTrigger>
                                                        </Form.Label>
                                                        {defaultBranding.length === 0 ? <div class="theme-loader">
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                        </div> : <select
                                                            className="form-select"
                                                            value={selectedDefaultBranding}
                                                            onChange={handleDefaultThemeChange}
                                                        >
                                                            <option value="none-selected">----</option>
                                                            {defaultBranding.length !== 0 && defaultBranding.map((item) => (
                                                                <option key={item.themeId} value={item.themeId}>
                                                                    {item.domain.toUpperCase()}
                                                                </option>
                                                            ))}
                                                        </select>}


                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Background</Form.Label>
                                                        <Form.Group controlId="formBranding1" className="d-flex">
                                                            <input type="color" placeholder="Enter Color" class="form-control form-control-color" name="BackGround" value={brandings.BackGround} onChange={handleColorChange} />
                                                            <input type="text" placeholder="Enter Color" class="form-control" name="BackGround" value={brandings.BackGround}
                                                                onChange={handleColorInputChange}
                                                                onBlur={handleColorInputBlur} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Primary Text</Form.Label>
                                                        <Form.Group controlId="formBranding1" className="d-flex">
                                                            <input type="color" placeholder="Enter Color" class="form-control form-control-color" name="PrimaryText" value={brandings.PrimaryText} onChange={handleColorChange} />
                                                            <input type="text" placeholder="Enter Color" class="form-control" name="PrimaryText" value={brandings.PrimaryText}
                                                                onChange={handleColorInputChange}
                                                                onBlur={handleColorInputBlur} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Text</Form.Label>
                                                        <Form.Group controlId="formBranding1" className="d-flex">
                                                            <input type="color" placeholder="Enter Color" class="form-control form-control-color" name="SecondaryText" value={brandings.SecondaryText} onChange={handleColorChange} />
                                                            <input type="text" placeholder="Enter Color" class="form-control" name="SecondaryText" value={brandings.SecondaryText}
                                                                onChange={handleColorInputChange}
                                                                onBlur={handleColorInputBlur} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Icon</Form.Label>
                                                        <Form.Group controlId="formBranding1" className="d-flex">
                                                            <input type="color" placeholder="Enter Color" class="form-control form-control-color" name="SecondaryIcon" value={brandings.SecondaryIcon} onChange={handleColorChange} />
                                                            <input type="text" placeholder="Enter Color" class="form-control" name="SecondaryIcon" value={brandings.SecondaryIcon}
                                                                onChange={handleColorInputChange}
                                                                onBlur={handleColorInputBlur} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Button Back</Form.Label>
                                                        <Form.Group controlId="formBranding1" className="d-flex">
                                                            <input type="color" placeholder="Enter Color" class="form-control form-control-color" name="ButtonBack" value={brandings.ButtonBack} onChange={handleColorChange} />
                                                            <input type="text" placeholder="Enter Color" class="form-control" name="ButtonBack" value={brandings.ButtonBack}
                                                                onChange={handleColorInputChange}
                                                                onBlur={handleColorInputBlur} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Button Text</Form.Label>
                                                        <Form.Group controlId="formBranding1" className="d-flex">
                                                            <input type="color" placeholder="Enter Color" class="form-control form-control-color" name="ButtonText" value={brandings.ButtonText} onChange={handleColorChange} />
                                                            <input type="text" placeholder="Enter Color" class="form-control" name="ButtonText" value={brandings.ButtonText}
                                                                onChange={handleColorInputChange}
                                                                onBlur={handleColorInputBlur} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Header Back</Form.Label>
                                                        <Form.Group controlId="formBranding1" className="d-flex">
                                                            <input type="color" placeholder="Enter Color" class="form-control form-control-color" name="HeaderBack" value={brandings.HeaderBack} onChange={handleColorChange} />
                                                            <input type="text" placeholder="Enter Color" class="form-control" name="HeaderBack" value={brandings.HeaderBack}
                                                                onChange={handleColorInputChange}
                                                                onBlur={handleColorInputBlur} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Header Text</Form.Label>
                                                        <Form.Group controlId="formBranding1" className="d-flex">
                                                            <input type="color" placeholder="Enter Color" class="form-control form-control-color" name="HeaderText" value={brandings.HeaderText} onChange={handleColorChange} />
                                                            <input type="text" placeholder="Enter Color" class="form-control" name="HeaderText" value={brandings.HeaderText}
                                                                onChange={handleColorInputChange}
                                                                onBlur={handleColorInputBlur} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label>Domain Name
                                                            <OverlayTrigger placement="right" overlay={<Tooltip style={{ width: '500px' }}>This is the url to access your branded service, enter the name to appear before cloudcoverservice.co.uk. e.g. partner.cloudcoverservice.co.uk. This must be entered to save your branding, you will need to notify our support team to enable your URL.</Tooltip>}>
                                                                <InfoCircle className="ms-2" />
                                                            </OverlayTrigger>
                                                        </Form.Label>
                                                        <input type="text" placeholder="Enter Domain Name" class="form-control" name="Domain" value={brandings.Domain}
                                                            onChange={handleColorInputChange} />
                                                    </Col>
                                                </Row>
                                                {isSaving ? <Button variant="primary" style={{ width: '64px' }}>
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                </Button> : <Button variant="primary" onClick={brandingSave} disabled={isSaving}>
                                                    Save
                                                </Button>}
                                                
                                                
                                                
                                            </Card.Body>
                                        </Card>
                                    </Col>    
                                }
                                
                    </Col>
                            <Col sm={12} md={6} className="ps-0">
                                
                                <Col md={12} className="mb-3"><Card style={{}} id="EndUserRecovery">
                                            <Card.Header className="setting_header SectionTitle">END USER RECOVERY</Card.Header>
                                    <Card.Body>
                                        <Card.Text>
                                            <Form.Label>This functionality has now been replaced with a more granular control for selecting users who can perform restores:</Form.Label>
                                        </Card.Text>
                                        <ul>
                                            <li>Find the CloudCover365EndUserRecovery group in your tenant.</li>
                                            <li>If group does not exist, you can create it by signing up again.</li>
                                            <li>Add users or groups of users to this group.</li>
                                        </ul>

                                    {/*    <Form.Check type="checkbox" id="ChkBoxEndUserRecovery" label="Enable End User Recovery for my organisation" name="EndUserRecovery" checked={endUserRecovery === 'true'} onChange={handleendUserRecovery} disabled={isDisabled} />*/}
                                    </Card.Body>
                                </Card></Col>
                                <Col md={12} className="mb-3"><Card style={{}} id="BackupNotification">
                                            <Card.Header className="setting_header SectionTitle">SUPPORT CONTACT</Card.Header>
                                            <Card.Body>
                                                <Card.Text>
                                                    Primary support email contact:
                                                </Card.Text>
                                                <Form>
                                                    <Form.Group controlId="formNotificationEmail">
                                                        <Form.Label>Email address</Form.Label>
                                                        <InputGroup className="mb-3">
                                                            <Form.Control
                                                                type="email" placeholder="Enter email" isInvalid={!validation.isNotificationEmailValid} onChange={notificationEmailChange} value={notificationEmailAddress}
                                                            />
                                                            <Button variant="primary" onClick={NotificationEmailUpdate}>Update</Button>
                                                        </InputGroup>
                                                        <Form.Control.Feedback type="invalid">
                                                            {validation.notificationEmailErrorMessage}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form>
                                                {/*<Card.Text>*/}
                                                {/*    <Form>*/}
                                                {/*        <Form.Label>Please select a notification type:</Form.Label>*/}
                                                {/*        <Form.Group controlId="formNotificationType" className="d-flex">*/}
                                                {/*            <Form.Check type="radio" id="notificationTypeFail" label="Failure" name="notificationType" checked={notificationType === "fail"} onChange={() => handleNotificationTypeClick("fail")} />*/}
                                                {/*            <Form.Check type="radio" id="notificationTypeWrng" label="Failure and Warning" name="notificationType" checked={notificationType === "fw"} onChange={() => handleNotificationTypeClick("fw")} />*/}
                                                {/*            <Form.Check type="radio" id="notificationTypeNone" label="None" name="notificationType" checked={notificationType === "none"} onChange={() => handleNotificationTypeClick("none")} />*/}
                                                {/*            <Form.Check type="radio" id="notificationTypeAll" label="All" name="notificationType" checked={notificationType === "all"} onChange={() => handleNotificationTypeClick("all")} />*/}
                                                {/*        </Form.Group>*/}
                                                {/*    </Form>*/}
                                                {/*</Card.Text>*/}
                                                <Card.Text>
                                                    Below, you can configure and customize email notifications, which will be sent to the following email addresses.
                                                </Card.Text>
                                       
                                                <Form>
                                                    <Form.Group controlId="formNotificationEmail">
                                                        <Button variant="primary" onClick={PopUpForNotificationEmail}>Manage Notifications Mails</Button>
                                                    </Form.Group>
                                                </Form>
                                                <div className="ag-theme-alpine mt-2">
                                                    <AgGridReact
                                                        rowData={rowData}
                                                        columnDefs={[
                                                            {
                                                                headerName: "Email ID",
                                                                field: "email",
                                                                minWidth: 200,
                                                                flex: 1,
                                                            },
                                                            {
                                                                headerName: "Failure",
                                                                field: "failure",
                                                                headerStyle: { textAlign: "center", fontWeight: "bold" },
                                                                headerComponentParams: {
                                                                    style: { display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" },
                                                                },
                                                                //cellStyle: { textAlign: "center" },
                                                                cellRenderer: (params) => (
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={params.value || false}
                                                                        disabled={true }
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            accentColor: "rgb(81, 145, 206)",
                                                                        }}
                                                                    />
                                                                ),
                                                                flex: 1,
                                                                minWidth: 100
                                                            },
                                                            {
                                                                headerName: "Success",
                                                                field: "success",
                                                                headerStyle: { textAlign: "center", fontWeight: "bold" },
                                                                headerComponentParams: {
                                                                    style: { display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" },
                                                                },
                                                                //cellStyle: { textAlign: "center" },
                                                                cellRenderer: (params) => (
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={params.value || false}
                                                                        disabled={true}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            accentColor: "rgb(81, 145, 206)",
                                                                        }}
                                                                    />
                                                                ),
                                                                flex: 1,
                                                                minWidth: 100
                                                            },
                                                            {
                                                                headerName: "Warning",
                                                                field: "warning",
                                                                headerStyle: { textAlign: "center", fontWeight: "bold" },
                                                                headerComponentParams: {
                                                                    style: { display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" },
                                                                },
                                                                //cellStyle: { textAlign: "center" },
                                                                cellRenderer: (params) => (
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={params.value || false}
                                                                        disabled={true}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            accentColor: "rgb(81, 145, 206)",
                                                                        }}
                                                                    />
                                                                ),
                                                                flex: 1,
                                                                minWidth: 100
                                                            },
                                                            {
                                                                headerName: "Restore",
                                                                field: "restore",
                                                                headerStyle: { textAlign: "center", fontWeight: "bold" },
                                                                headerComponentParams: {
                                                                    style: { display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" },
                                                                },
                                                                //cellStyle: { textAlign: "center" },
                                                                cellRenderer: (params) => (
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={params.value || false}
                                                                        disabled={true}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            accentColor: "rgb(81, 145, 206)",
                                                                        }}
                                                                    />
                                                                ),
                                                                flex: 1,
                                                                minWidth: 100
                                                            }
                                                        ]}
                                                        defaultColDef={defaultColDef}
                                                        domLayout="autoHeight"
                                                        overlayNoRowsTemplate='<span class="ag-overlay-no-rows-center">No Emails are available to display</span>'                                            />
                                                </div>
                                                <Card.Text className="mt-3">
                                                    New style notifications
                                                </Card.Text>
                                                <Form>
                                                    <Form.Group controlId="formNewStyleNotifications">
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div
                                                                onClick={handleNewStyleNotificationsChange}
                                                                style={{
                                                                    width: '50px',
                                                                    height: '24px',
                                                                    borderRadius: '9999px',
                                                                    backgroundColor: newStyleNotificationsSlide ? '#0f5730' : '#ccc',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    position: 'relative',
                                                                    cursor: 'pointer',
                                                                    transition: 'background-color 0.3s ease'
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: newStyleNotificationsSlide ? '26px' : '2px',
                                                                        top: '2px',
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: '#fff',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        transition: 'left 0.3s ease'
                                                                    }}
                                                                >
                                                                    {newStyleNotificationsSlide && (
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="12"
                                                                            height="12"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            stroke="#0f5730"
                                                                            strokeWidth="3"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        >
                                                                            <polyline points="20 6 9 17 4 12" />
                                                                        </svg>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <span
                                                                style={{
                                                                    marginLeft: '8px',
                                                                    fontSize: '12px',
                                                                    fontWeight: 'bold',
                                                                    color: newStyleNotificationsSlide ? '#0f5730' : '#999'
                                                                }}
                                                            >
                                                                {newStyleNotificationsSlide ? 'ON' : 'OFF'}
                                                            </span>
                                                        </div>
                                                    </Form.Group>
                                                </Form>

                                                <Card.Text className="mt-3">
                                                    Suppression expiry warnings
                                                </Card.Text>
                                                <Form>
                                                    <Form.Group controlId="formSuppressionExpiryWarnings">
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div
                                                                onClick={handleSuppressionExpiryChange}
                                                                style={{
                                                                    width: '50px',
                                                                    height: '24px',
                                                                    borderRadius: '9999px',
                                                                    backgroundColor: suppressionExpirySlide ? '#0f5730' : '#ccc',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    position: 'relative',
                                                                    cursor: 'pointer',
                                                                    transition: 'background-color 0.3s ease'
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: suppressionExpirySlide ? '26px' : '2px',
                                                                        top: '2px',
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: '#fff',
                                                                        transition: 'left 0.3s ease'
                                                                    }}
                                                                />
                                                            </div>
                                                            <span
                                                                style={{
                                                                    marginLeft: '8px',
                                                                    fontSize: '12px',
                                                                    fontWeight: 'bold',
                                                                    color: suppressionExpirySlide ? '#0f5730' : '#999'
                                                                }}
                                                            >
                                                                {suppressionExpirySlide ? 'ON' : 'OFF'}
                                                            </span>
                                                        </div>
                                                        <Form.Text className="text-muted">
                                                            Email this organisation 3 days before an error suppression expires.
                                                        </Form.Text>
                                                    </Form.Group>
                                                </Form>

                                            </Card.Body>
                                        </Card></Col>
                                <Col md={12} className="mb-3">
                                    <Card id="GranularAccess">
                                        <Card.Header className="setting_header SectionTitle">GRANULAR ACCESS</Card.Header>
                                        <Card.Body>
                                            <Card.Text>
                                                <Form.Label>
                                                    To enhance security, it's important to control who can perform specific backup and restore operations.These are the security groups we use and their permissions, if you did not select to add them at sign up you can configure them you can configure them later by signing up again.
                                                </Form.Label>
                                            </Card.Text>
                                            <Form>
                                                <div style={{ marginLeft: '25px' }}>
                                                    <div style={{ marginBottom: '8px' }}>
                                                        <ul>
                                                            <li style={{ marginLeft: '6px', fontSize: '15px' }}>CloudCover365Admin - Master Administration Accounts, complete access to all functions.</li>
                                                            <li style={{ marginLeft: '6px', fontSize: '15px' }}>CloudCover365Engineer - As Above, but cannot maintain system settings.</li>
                                                            <li style={{ marginLeft: '6px', fontSize: '15px' }}>CloudCover365JobManagement - Can only manage and monitor jobs.</li>
                                                            <li style={{ marginLeft: '6px', fontSize: '15px' }}>CloudCover365Restore - Can only perform restore functions.</li>
                                                            <li style={{ marginLeft: '6px', fontSize: '15px' }}>CloudCover365EndUserRecovery - Can only perform restore functions with their own Backup.</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            {/*    <div style={{ marginLeft: '25px' }}>*/}
                                            {/*        <div style={{ marginBottom: '8px' }}>*/}
                                            {/*            <label style={{ cursor: 'pointer' }}>*/}
                                            {/*                <input*/}
                                            {/*                    type="checkbox"*/}
                                            {/*                    name="VeeamAdmin"*/}
                                            {/*                    checked={checkboxes.VeeamAdmin}*/}
                                            {/*                    // disabled={disabledCheckboxes.VeeamAdmin}*/}
                                            {/*                    disabled={true}*/}
                                            {/*                    onChange={handleCheckboxChange}*/}
                                            {/*                />*/}
                                            {/*                <span style={{ marginLeft: '6px', fontSize: '15px' }}>Veeam365Admin - Master Administration Accounts, complete access to all functions.</span>*/}
                                            {/*            </label>*/}
                                            {/*        </div>*/}
                                            {/*        <div style={{ marginBottom: '8px' }}>*/}
                                            {/*            <label style={{ cursor: 'pointer' }}>*/}
                                            {/*                <input*/}
                                            {/*                    type="checkbox"*/}
                                            {/*                    name="Setting"*/}
                                            {/*                    checked={checkboxes.Setting}*/}
                                            {/*                    //disabled={disabledCheckboxes.Setting}*/}
                                            {/*                    disabled={true}*/}
                                            {/*                    onChange={handleCheckboxChange}*/}
                                            {/*                />*/}
                                            {/*                <span style={{ marginLeft: '6px', fontSize: '15px' }}>Veeam365Engineer - As Above, but cannot maintain system settings.</span>*/}
                                            {/*            </label>*/}
                                            {/*        </div>*/}
                                            {/*        <div style={{ marginBottom: '8px' }}>*/}
                                            {/*            <label style={{ cursor: 'pointer' }}>*/}
                                            {/*                <input*/}
                                            {/*                    type="checkbox"*/}
                                            {/*                    name="MainPage"*/}
                                            {/*                    checked={checkboxes.MainPage}*/}
                                            {/*                    //disabled={disabledCheckboxes.MainPage}*/}
                                            {/*                    disabled={true}*/}
                                            {/*                    onChange={handleCheckboxChange}*/}
                                            {/*                />*/}
                                            {/*                <span style={{ marginLeft: '6px', fontSize: '15px' }}>Veeam365JobManagement - Can only manage and monitor jobs.</span>*/}
                                            {/*            </label>*/}
                                            {/*        </div>*/}
                                            {/*        <div style={{ marginBottom: '8px' }}>*/}
                                            {/*            <label style={{ cursor: 'pointer' }}>*/}
                                            {/*                <input*/}
                                            {/*                    type="checkbox"*/}
                                            {/*                    name="RestorePage"*/}
                                            {/*                    checked={checkboxes.RestorePage}*/}
                                            {/*                    //disabled={disabledCheckboxes.RestorePage}*/}
                                            {/*                    disabled={true}*/}
                                            {/*                    onChange={handleCheckboxChange}*/}
                                            {/*                />*/}
                                            {/*                <span style={{ marginLeft: '6px', fontSize: '15px' }}>Veeam365Restore - Can only perform restore functions.</span>*/}
                                            {/*            </label>*/}
                                            {/*        </div>*/}
                                            {/*        <div style={{ marginBottom: '8px' }}>*/}
                                            {/*            <label style={{ cursor: 'pointer' }}>*/}
                                            {/*                <input*/}
                                            {/*                    type="checkbox"*/}
                                            {/*                    name="EndUserRestore"*/}
                                            {/*                    checked={checkboxes.EndUserRestore}*/}
                                            {/*                    // disabled={disabledCheckboxes.EndUserRestore}*/}
                                            {/*                    disabled={true}*/}
                                            {/*                    onChange={handleCheckboxChange}*/}
                                            {/*                />*/}
                                            {/*                <span style={{ marginLeft: '6px', fontSize: '15px' }}>Veeam365EndUserRecovery - Can only perform restore functions with their own Backup.</span>*/}
                                            {/*            </label>*/}
                                            {/*        </div>*/}
                                            {/*    </div>*/}
                                            {/*    <Form.Label>*/}
                                            {/*        note: Created user groups cannot be deleted from the settings page.*/}
                                            {/*</Form.Label>*/}
                                            </Form>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col md={12}><Card style={{}}>
                                    <Card.Header className="setting_header SectionTitle">STORAGE ENCRYPTION</Card.Header>
                            <Card.Body>
                                <Card.Text>
                                    CloudCover 365 allows you to configure a password that you can use to encrypt data in object storage repositories using the AES-256 specification.
                                </Card.Text>
                                <Form>
                                    <Form.Group controlId="formStorageEncryption">
                                        <Form.Label>Encryption Key</Form.Label>
                                        {encryption === "true" ? (<Form.Control type="password" value="" disabled placeholder="Already Enabled" />
                                        )
                                            : (<InputGroup className="mb-3">
                                                <Form.Control type="password" isInvalid={!validation.isEncryptionValid} onChange={(event) => {
                                                            const updatedEncryption = event.target.parentElement.parentElement.querySelector('input[type="password"]').value;


                                                            if (updatedEncryption === "") {
                                                                setValidation({
                                                                    ...validation,
                                                                    isEncryptionValid: false,
                                                                    encryptionErrorMessage: "Encryption Key should not be Empty"
                                                                });

                                                            }
                                                            else {
                                                                setValidation({
                                                                    ...validation,
                                                                    isEncryptionKeyValid: true,
                                                                    encryptionErrorMessage: ""
                                                                });
                                                            }

                                                        }} placeholder="Enter Encryption Key" />
                                                <Button variant="primary" value="" onClick={encryptionUpdate}>Update</Button>
                                        </InputGroup>)
                                        }
                                        <Form.Control.Feedback type="invalid">
                                            {validation.encryptionErrorMessage}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                   
                                </Form>
                            </Card.Body>
                        </Card></Col>

                    </Col> 
                </Row>
                )}
            </div>
            <Modal
                show={popUp}
                onHide={closeModal}
                centered
                size="lg"
                id="notification_modal"
            >
                <Modal.Header style={{ padding: 0 }}>
                    <Modal.Title id="exampleModalLabel" style={{ textAlign: "left", width: "100%" }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: "10px" }}>BACKUP NOTIFICATIONS</h3>
                            <button type="button" className="btn-close" aria-label="Close" style={{ transform: 'scale(0.75)', marginRight: "5px" }} onClick={closeModal}></button>
                        </div>

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/*<hr style={{ borderTop: "1px solid #2671bfcc", margin: "10epx 0" }} />*/}
                    <p style={{ margin: "10px" }}>Please select the Notification feature for the corresponding email addresses.</p>
                    {false && <div style={{ position: 'absolute', height: '100%', width: '96%', background: 'white', top: '0px', opacity: '0.8' }}>
                        <div className="justify-content-center align-items-center d-flex h-100" >
                            <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                        </div>
                    </div>}
                    <div style={{ padding: "0px 5px 0px 5px" }}>
                        <Form.Group controlId="restoreReason">
                            <InputGroup className="mb-3">
                                <Form.Control
                                    type="addemail" placeholder="Enter email" isInvalid={!emailValidation.isNotificationEmailValid} onChange={addNotificationEmailChange} value={addNotificationEmail}
                                />
                                <Button variant="primary" onClick={handleAddMail} disabled={emailValidation.disabled || isSubmitting}>Add New Notification Mail</Button>
                            </InputGroup>
                            <div className="mb-2" >
                                <div style={{ fontFamily: "'Poppins', sans-serif", color: "red", fontSize: '13px' }} >{emailValidation.notificationEmailErrorMessage}{" "}</div>
                            </div>
                            <Form.Control.Feedback type="invalid">
                                {emailValidation.notificationEmailErrorMessage}
                            </Form.Control.Feedback>
                            <div className="ag-theme-alpine">
                                <AgGridReact
                                    rowData={rowData}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    frameworkComponents={frameworkComponents}
                                    domLayout="autoHeight"
                                />
                            </div>
                        </Form.Group>
                    </div>
                </Modal.Body>

                {/*<Modal.Footer>*/}
                {/*    <Button variant="secondary" onClick={addUser} >*/}
                {/*        Add Users*/}
                {/*    </Button>*/}
                {/*    <Button variant="secondary" onClick={deleteUser} >*/}
                {/*        Delete Users*/}
                {/*    </Button>*/}
                {/*    */}{/*<Button variant="primary" onClick={() => postRestoreComment(textValue)} disabled={!textValue.trim()}>*/}
                {/*    */}{/*    Continue*/}
                {/*    */}{/*</Button>*/}
                {/*</Modal.Footer>*/}
            </Modal>
            <Modal
                show={deleteConfirmPopUp}
                onHide={closeModal}
                centered
                size="lg"
            >
                <Modal.Header style={{ padding: 0 }}>
                    <Modal.Title id="exampleModalLabel" style={{ textAlign: "left", width: "100%" }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: "10px" }}>DELETE MAIL NOTIFICATIONS</h3>
                            <button type="button" className="btn-close" aria-label="Close" style={{ transform: 'scale(0.75)', marginRight: "5px" }} onClick={closeModal}></button>
                        </div>

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/*<hr style={{ borderTop: "1px solid #2671bfcc", margin: "10epx 0" }} />*/}
                    <h5 style={{ margin: "10px" }}>Are you sure you want to delete the notification mail "{notifyMails.email}"?</h5>
                    {false && <div style={{ position: 'absolute', height: '100%', width: '96%', background: 'white', top: '0px', opacity: '0.8' }}>
                        <div className="justify-content-center align-items-center d-flex h-100" >
                            <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                        </div>
                    </div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={deleteUser} >
                        Confirm
                    </Button>
                    <Button variant="secondary" onClick={() => {
                        setDeleteConfirmPopUp(false);
                        PopUpForNotificationEmail();
                    }} >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

        </Container>
    );
}

export default Settings;
